const PT = {
  '1': 'Janeiro',
  '2': 'Fevereiro',
  '3': 'Marchar',
  '4': 'Abril',
  '5': 'Poderia',
  '6': 'Junho',
  '7': 'Julho',
  '8': 'Agosto',
  '9': 'Setembro',
  '10': 'Outubro',
  '11': 'Novembro',
  '12': 'Dezembro',
  'Admob_text7': 'Em Preparação',
  'Admob_text8': 'O Vídeo Ainda Não Está Pronto',
  'AnchorCenter_biList_interaction_Popup1': 'Você Recebeu Mensagens De \'X\' Usuários',
  'AnchorCenter_biList_interaction_Popup10': 'Exemplo: Você Enviou Mensagens Para 100 Usuários E 50 Deles Responderam. Sua Taxa De Resposta Efetiva (Uv) = 50/100 = 50%.',
  'AnchorCenter_biList_interaction_Popup11': 'Taxa De Resposta Efetiva: Conta Apenas As Respostas Recebidas Antes Do Tempo Limite',
  'AnchorCenter_biList_interaction_Popup12': 'Você Enviou \'X\' Mensagens',
  'AnchorCenter_biList_interaction_Popup13': 'Das \'X\' Mensagens Que Você Enviou, \'N\' Foram Respondidas Efetivamente',
  'AnchorCenter_biList_interaction_Popup14': 'Porcentagem De Suas Mensagens Respondidas (Pv)',
  'AnchorCenter_biList_interaction_Popup15': 'Exemplo: Você Enviou 100 Mensagens E 70 Delas Foram Respondidas Com Eficiência. Sua Taxa De Resposta Efetiva (Vp) = 70/100 = 70%.',
  'AnchorCenter_biList_interaction_Popup16': 'Taxa De Resposta Efetiva: Conta Apenas As Respostas Recebidas Antes Do Tempo Limite',
  'AnchorCenter_biList_interaction_Popup2': 'Você Respondeu A \'N\' De \'X\' Usuários Que Lhe Enviaram Mensagens',
  'AnchorCenter_biList_interaction_Popup3': 'Exemplo: Você Recebeu Mensagens De 100 Usuários E Respondeu Efetivamente A 90 Deles. Sua Taxa De Resposta Efetiva (Uv) = 90/100 = 90%.',
  'AnchorCenter_biList_interaction_Popup4': 'Porcentagem De Resposta À Mensagem (Uv)',
  'AnchorCenter_biList_interaction_Popup5': 'Taxa De Resposta Efetiva: Conta Apenas Os Usuários Que Foram Respondidos Antes Do Tempo Limite',
  'AnchorCenter_biList_interaction_Popup6': 'Entendi',
  'AnchorCenter_biList_interaction_Popup7': 'Você Enviou Mensagens Para \'X\' Usuários',
  'AnchorCenter_biList_interaction_Popup8': 'Dos \'X\' Usuários Para Quem Você Enviou Mensagens E \'N\' Respondeu',
  'AnchorCenter_biList_interaction_Popup9': 'Porcentagem De Usuários Que Responderam (Uv)',
  'AnchorCenter_biList_interaction_text1': 'Interação',
  'AnchorCenter_biList_interaction_text10': 'Suas Mensagens Respondidas (Uv)',
  'AnchorCenter_biList_interaction_text11': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text12': 'Mensagens Enviadas (Pv)',
  'AnchorCenter_biList_interaction_text13': 'Suas Mensagens Respondidas (Pv)',
  'AnchorCenter_biList_interaction_text14': 'Taxa De Resposta (Pv)',
  'AnchorCenter_biList_interaction_text2': 'Bate-Papos Iniciados (Uv)',
  'AnchorCenter_biList_interaction_text3': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text4': 'Taxa De Resposta (Pv)',
  'AnchorCenter_biList_interaction_text5': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text6': 'Mensagens Recebidas (Uv)',
  'AnchorCenter_biList_interaction_text7': 'Mensagens Respondidas (Uv)',
  'AnchorCenter_biList_interaction_text8': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text9': 'Mensagens Enviadas (Uv)',
  'Anonymity_name': 'Anonimato',
  'Charge_Same_1': 'Você Enviou O Mesmo Valor De Recarga Para Este Usuário Recentemente E A Transação Foi Bem-Sucedida. Deseja Prosseguir Novamente?',
  'Charge_Same_2': 'Cancelar Pagamento',
  'Charge_Same_3': 'Prosseguir Com O Pagamento',
  'Double_Rewards_text1': 'Torne-Se Svip E Ganhe Recompensas Em Dobro!',
  'EXP': 'Exp',
  'Experience_Card_Statement': '*Os Cartões De Experiência Não Têm Esse Benefício',
  'Hate': 'Odiar',
  'Noble_Change_2': 'Condições De Compra: Ranks Mais Baixos Podem Comprar Ranks Mais Altos, Mas Ranks Mais Altos Não Podem Comprar Ranks Mais Baixos. Por Exemplo, Se Você For Atualmente Um Conde, Só Poderá Comprar Marquês, Duque Ou Rei.',
  'Noble_Change_3': 'Lógica De Conversão: Se Você Já For Um Aristocrata, Após Comprar Outra Patente Aristocrática, O Período De Validade Restante Da Antiga Patente Aristocrática Será Convertido Para A Nova Patente Aristocrática Com Base Na Proporção Do Preço Da Moeda, E A Antiga Patente Aristocrática Se Tornará Inválida.',
  'Noble_Change_4': 'Fórmula De Cálculo Do Período De Validade: Novo Período De Validade Da Aristocracia Adquirida = Dias Restantes Da Classificação Aristocrática Atual * (Preço Da Classificação Aristocrática Atual / Preço Da Classificação Aristocrática Adquirida) + 30, O Número Final De Dias É Arredondado Para Baixo.',
  'Noble_Change_5': 'Exemplo: Se Você For Atualmente Um Visconde (99990 Moedas/Mês), Com 13 Dias Restantes, E Comprar Um Conde (199990 Moedas/Mês) Hoje, Então, Após O Pagamento, O Período De Validade Do Conde Será 13 * (99990/199990) + 30 = 6,5 Arredondado Para Baixo + 30 = 36 Dias.',
  'OfficialTaskPic_Level_text1': 'Recompensas Diárias De Renda De Diamantes (Mensagem Instantânea)',
  'OfficialTaskPic_Level_text10': 'Recompensa Diamante',
  'OfficialTaskPic_Level_text11': 'Perceber:',
  'OfficialTaskPic_Level_text12': '1. Presente Para Sala De Voz: Incluindo Sala De Voz Normal E Sala De Voz Familiar;',
  'OfficialTaskPic_Level_text13': '2. Recompensa Ativa Do Período De Trabalho: Após O Término Do Período, O Número De Dias Ativos Será Contado, E A Recompensa Máxima Que Você Pode Obter É 350 Diamantes;',
  'OfficialTaskPic_Level_text14': '3. Todas As Recompensas De Diamantes Serão Enviadas Diretamente Para Sua Conta Durante Este Período De Trabalho;',
  'OfficialTaskPic_Level_text15': '4. Cada 100 Diamantes = 1 Usd',
  'OfficialTaskPic_Level_text16': 'Recompensa Diária (Por Presentes Em Chats, Chamadas De Áudio E Vídeo, Correspondência De Áudio)',
  'OfficialTaskPic_Level_text17': 'Se Você Receber Diamantes Como Presentes Em Chats, Chamadas De Áudio E Vídeo, Partidas De Áudio E Atingir A Meta Diária, Receberá A Recompensa De Diamante Correspondente. As Recompensas De Diamante Serão Adicionadas À Sua Conta Automaticamente No Dia Seguinte.',
  'OfficialTaskPic_Level_text18': 'Recompensa Diária (Por Presentes Em Chats E Salas De Voz)',
  'OfficialTaskPic_Level_text19': 'Recompensa Pelo Período De Trabalho (Para Chamadas De Áudio E Vídeo)',
  'OfficialTaskPic_Level_text2': 'Nível',
  'OfficialTaskPic_Level_text20': '1. Se Você Receber Diamantes Como Presentes Em Chats E Salas De Voz E Atingir A Meta Diária, Receberá A Recompensa De Diamante Correspondente. As Recompensas De Diamante Serão Adicionadas Automaticamente À Sua Conta No Dia Seguinte.',
  'OfficialTaskPic_Level_text21': '2. Se Você Receber Diamantes Por Chamadas De Áudio E Vídeo E Atingir A Meta Até O Final Do Período De Trabalho, Receberá A Recompensa De Diamante Correspondente. As Recompensas De Diamante Serão Adicionadas Automaticamente À Sua Conta No Dia Seguinte Ao Término Do Período De Trabalho.',
  'OfficialTaskPic_Level_text22': '3. Há 2 Períodos De Trabalho Que Duram Do Dia 1 Ao Dia 15 De Cada Mês E Do Dia 16 Ao Dia 30/31 De Cada Mês.',
  'OfficialTaskPic_Level_text23': 'Recompensa Diária 1 (Sala De Festa De Áudio E Diamante De Presente Para A Família)',
  'OfficialTaskPic_Level_text24': 'Recompensa Diária 2 (Chamada De Voz, Diamante De Correspondência De Voz)',
  'OfficialTaskPic_Level_text25': 'Recompensa Por Período De Trabalho (Bate-Papo, Sala De Áudio, Chamadas De Voz, Correspondência De Áudio)',
  'OfficialTaskPic_Level_text26': '1. Se Você Receber Diamantes Como Presentes Em Chats, Salas De Áudio E Chamadas De Vídeo, Partidas De Áudio E Atingir A Meta Semanal, Receberá A Recompensa De Diamante Correspondente. As Recompensas De Diamante Serão Adicionadas Automaticamente À Sua Conta Neste Período De Salário.',
  'OfficialTaskPic_Level_text27': '2. Taxa Salarial: 100 Diamantes = 1 Usd;',
  'OfficialTaskPic_Level_text28': '3. Os Diamantes Obtidos Com Recompensas Diárias Não Serão Contabilizados Para Esta Meta De Diamantes;',
  'OfficialTaskPic_Level_text29': 'Sistema Oficial De Recompensas Soyou 02.2024',
  'OfficialTaskPic_Level_text3': 'Alvo De Diamante',
  'OfficialTaskPic_Level_text30': 'Tarefa Diária 1: Todas As Chamadas + Todos Os Presentes',
  'OfficialTaskPic_Level_text31': 'Missão Diária 2: Resposta À Mensagem',
  'OfficialTaskPic_Level_text32': 'Meta Diária De Diamantes',
  'OfficialTaskPic_Level_text33': 'Nossa Meta Diária De Diamantes É Mostrada Acima, E Um Dia Em Nosso Sistema De Recompensas É Baseado No Horário Local Da Turquia.',
  'OfficialTaskPic_Level_text4': 'Recompensa Diamante',
  'OfficialTaskPic_Level_text5': 'Recompensas Diárias De Renda De Diamantes (Presentes De Sala De Voz: Sala De Voz Normal + Sala De Voz Familiar)',
  'OfficialTaskPic_Level_text6': 'Recompensas De Renda Diamante Por Período De Trabalho (Mensagem Instantânea + Todos Os Presentes Recebidos)',
  'OfficialTaskPic_Level_text7': 'Recompensas Ativas Do Período De Trabalho',
  'OfficialTaskPic_Level_text8': 'Faça Login Por {%s1} Dias E Ganhe {%s2} Diamantes Todos Os Dias',
  'OfficialTaskPic_Level_text9': 'Exigência',
  'OfficialTask_ActiveCard_text1': 'Recompensa Ativa Do Período De Trabalho',
  'OfficialTask_ActiveCard_text2': 'Login Cumulativo No Ciclo {%s1} Dias ({%s2}/{%s3})',
  'OfficialTask_ActiveCard_text3': 'Se A Renda Diária De Diamantes Atingir {%s1} 💎, Você Poderá Obter {%s2} 💎. (Hoje: {%s3}/{%s4})',
  'OfficialTask_Card_common_text1': 'Tarefa Oficial',
  'OfficialTask_Card_common_text2': 'Após Completar A Tarefa Oficial De Recompensa, Você Pode Ganhar No Máximo {%s} Diamantes!',
  'OfficialTask_PeriodCard_text1': 'Recompensa Diamante Por Período De Trabalho ({%s1}/{%s2})',
  'OfficialTask_PeriodCard_text2': 'A Recompensa De Diamante Do Período De Trabalho ({%s3}) Atinge {%s1} 💎, Ganhe {%s2} 💎',
  'OfficialTask_dailyCard_text1': 'Recompensas Diárias De Renda De Diamantes ({%s1}/{%s2})',
  'OfficialTask_dailyCard_text2': 'A Renda Diária De Diamantes ({%s1}) Atinge {%s2} 💎, Receba {%s3} 💎',
  'OfficialTask_dailyCard_text3': 'As Recompensas Diárias De Renda De Diamantes ({%s3}) Atingem {%s1} 💎, Ganhe {%s2} 💎',
  'OfficialTask_dailyCard_text4': 'Hora Da Recompensa',
  'OfficialTask_dailyCard_text5': 'Ir',
  'OfficialTask_dailyCard_text6': 'Concluído',
  'OfficialTask_rewardTime_text1': 'Horas',
  'OfficialTask_rewardTime_text2': 'Minutos',
  'Official_website_payment_1': 'Recarga Online Soyou',
  'Official_website_payment_10': '3. Nenhuma Transação Offline É Suportada.',
  'Official_website_payment_11': '4. Não Divulgue As Informações Da Sua Conta A Ninguém, Por Nenhum Motivo Ou Método.',
  'Official_website_payment_12': '5. Você Não Será Responsabilizado Por Quaisquer Disputas Entre Usuários E Terceiros.',
  'Official_website_payment_13': '6. Se Houver Algum Problema Com A Recarga, Entre Em Contato Com O Atendimento Ao Cliente Ou Envie-Nos Um E-Mail.',
  'Official_website_payment_14': 'Prevenção À Lavagem De Dinheiro',
  'Official_website_payment_15': '1. O Usuário Deve Garantir Que Possui Identidade Legal E Capacidade Para Usar Os Serviços Fornecidos Por Nós E Não Participará Ou Estará Associado A Nenhuma Atividade Criminosa.',
  'Official_website_payment_16': '2. A Conta De Usuário É Para Seu Uso Exclusivo E Pertence Somente A Você. Você Não Pode Transferir, Alugar Ou Alienar Sua Conta A Terceiros.',
  'Official_website_payment_17': '3. O Usuário Deve Garantir Que Todo O Dinheiro Usado Para Recargas Seja Obtido Por Meios Legais E Não Esteja, Em Nenhum Momento, Associado A Atividades Ou Comportamentos Criminosos.',
  'Official_website_payment_18': 'Método De Pagamento',
  'Official_website_payment_19': 'Atualmente Usando O Canal De Pagamento {%s}',
  'Official_website_payment_2': 'Id De Recarga',
  'Official_website_payment_20': 'Opção De Recarga',
  'Official_website_payment_21': 'Mudar',
  'Official_website_payment_22': 'O Id Da Conta Não Existe!',
  'Official_website_payment_23': 'Nenhum Método De Pagamento Suportado Ainda',
  'Official_website_payment_24': 'Informe O Método De Pagamento Desejado',
  'Official_website_payment_25': 'Consultando Resultados De Transações',
  'Official_website_payment_26': 'Resultado Da Recarga A Ser Confirmado',
  'Official_website_payment_27': 'O Resultado Da Recarga Pode Demorar. Acesse O Aplicativo Para Verificar O Histórico De Recarga Da Conta. Se A Conta Não Chegar Por Um Longo Período, Entre Em Contato Com O Atendimento Ao Cliente.',
  'Official_website_payment_28': 'Atualizar',
  'Official_website_payment_29': 'Falha Na Recarga',
  'Official_website_payment_3': 'Digite O Id',
  'Official_website_payment_30': 'Informações De Ajuda:',
  'Official_website_payment_31': '1. Confirme Se O Valor E O Método De Pagamento Estão Corretos, Incluindo Informações Pessoais, Número Do Cartão De Crédito, Período De Validade, Código Cvv, Etc.',
  'Official_website_payment_32': '2. Verifique Se O Saldo Da Conta É Suficiente.',
  'Official_website_payment_33': '3. Verifique Se A Conexão De Rede Está Estável. Às Vezes, Problemas De Rede Podem Causar Falha No Pagamento.',
  'Official_website_payment_34': '4. Tente Mudar Para Outros Métodos De Pagamento Ou Tente Recarregar Mais Tarde.',
  'Official_website_payment_35': '5. Se O Problema Ainda Não For Resolvido, É Recomendável Entrar Em Contato Com O Atendimento Ao Cliente Da Plataforma De Recarga Para Obter Mais Ajuda.',
  'Official_website_payment_36': 'Recarga Bem-Sucedida',
  'Official_website_payment_37': 'Entre No Aplicativo Para Visualizar O Registro De Recarga Da Conta',
  'Official_website_payment_38': 'Falha No Tempo Limite Do Link',
  'Official_website_payment_39': 'O Link Expirou. Por Favor, Recrie O Link De Pagamento No Aplicativo.',
  'Official_website_payment_4': 'O Que É Id?',
  'Official_website_payment_5': 'Verifique Primeiro Para Proteger A Privacidade E A Segurança Da Conta.',
  'Official_website_payment_6': 'Consulta',
  'Official_website_payment_7': 'Aviso Aos Usuários',
  'Official_website_payment_8': '1. Não Compre Moedas Soyou Em Sites Não Oficiais Ou Não Autorizados Para Evitar Disputas Desnecessárias.',
  'Official_website_payment_9': '2. Não Confie Em Nenhuma Informação Não Oficial Publicada Em Outros Sites, Canais De Comunicação Ou Grupos De Comunicação. Todas As Informações Sobre O Evento Estão Sujeitas A Anúncio Oficial No Site Oficial Ou Por Meio De Aviso No Sistema.',
  'Privacy Policy': 'Política De Privacidade',
  'Registr_optimization_1': 'Problemas De Registro E Login',
  'Terms of Service': 'Termos De Serviço',
  'Tvwall_gift_10': 'Condições Da Tela De Bloqueio De Entrada:',
  'Tvwall_gift_11': 'Bloquear Tela Por 10 Segundos: Um Presente De Desejo É Concluído E O Valor Do Presente De Desejo Está Entre 2.000 Moedas E 9.999 Moedas;',
  'Tvwall_gift_12': 'Bloquear Tela Por 20 Segundos: Concluiu Um Presente De Desejo E O Valor Do Presente De Desejo Está Entre 10.000 Moedas E 49.999 Moedas;',
  'Tvwall_gift_13': 'Bloqueio De Tela Por 60 Segundos: Concluiu Um Presente De Desejo E O Valor Do Presente De Desejo É Superior A 50.000 Moedas',
  'Tvwall_gift_14': 'Condições Para Aparecer No Mural Da Tv Mundial:',
  'Tvwall_gift_15': 'Registro Comum: Concluiu Um Presente De Desejo E O Valor Do Presente De Desejo Está Entre 2.000 Moedas E 9.999 Moedas',
  'Tvwall_gift_16': 'Registro De Luxo: Concluiu Um Presente De Desejo E O Valor Do Presente De Desejo É Maior Ou Igual A 10.000 Moedas',
  'Tvwall_gift_17': 'Na Parede Da Tv',
  'Tvwall_gift_18': 'Anônimo Na Parede Da Tv',
  'Tvwall_gift_19': 'Não Na Parede Da Tv',
  'Tvwall_gift_32': 'A Entrega De Presentes Deve Ser Mostrada Na Tv?',
  'Tvwall_gift_33': '(Clique Para Selecionar E Entrar Em Vigor Imediatamente)',
  'Tvwall_gift_9': 'Listas De Desejos De Presentes Completas No Valor Igual Ou Superior A 2.000 Moedas Para Serem Exibidas No Mural Da Tv',
  'about.badges.0': 'Use O Distintivo',
  'about.badges.1': 'Todos Os Emblemas Podem Ser Usados, E Até Cinco Emblemas Podem Ser Usados ​​Ao Mesmo Tempo.',
  'about.badges.2': 'Distintivo De Honra',
  'about.badges.3': 'Os Emblemas Desbloqueados Pelos Valores Mensais Acumulados São Contabilizados No 1º Dia De Cada Mês, Independentemente De Possuírem Ou Não. O Período De Validade É De Um Mês.',
  'about.badges.title': 'Sobre Emblemas',
  'activity.gift.list.contributor': 'Classificação\nDos Colaboradores',
  'activity.gift.list.receive': 'Estrelas',
  'activity.gift.list.send': 'Contribuinte',
  'activity.gift.list.stars': 'Ranking de Estrelas',
  'all': 'Todos',
  'anchor.pk.PK.Times': 'Pk Times',
  'anchor.pk.coins': 'Moedas',
  'anchor.pk.countdown': 'Contagem Regressiva',
  'anchor.pk.daily.Ranking': 'Ranking Diário',
  'anchor.pk.days': 'Dias',
  'anchor.pk.duration': 'Duração',
  'anchor.pk.event.end': 'O Evento Acabou',
  'anchor.pk.exclusive.Sponsor': 'Patrocinador Exclusivo',
  'anchor.pk.hours': 'Horas',
  'anchor.pk.minutes': 'Minutos',
  'anchor.pk.queen': 'Rainha Do Glamour',
  'anchor.pk.queen.daily.rewards': 'Recompensas Do Ranking Diário Da Rainha Do Glamour',
  'anchor.pk.queen.total.rewards': 'Recompensas De Classificação Total Da Rainha Do Glamour',
  'anchor.pk.rank': 'Classificação',
  'anchor.pk.rewards': 'Recompensas',
  'anchor.pk.rules': 'Regras',
  'anchor.pk.rules.rewards': 'Regras E Recompensas',
  'anchor.pk.seconds': 'Segundos',
  'anchor.pk.sponsor': 'Patrocinador Exclusivo De Hoje',
  'anchor.pk.sponsor.daily.rewards': 'Recompensas De Classificação Diária Exclusivas Para Patrocinadores',
  'anchor.pk.sponsor.total.rewards': 'Recompensas De Classificação Total De Patrocinadores Exclusivos',
  'anchor.pk.target': 'Alvo',
  'anchor.pk.tools.rewards': 'Ferramentas Recompensas',
  'anchor.pk.total.Ranking': 'Classificação Total',
  'anchor.pk.win.Times': 'Tempos De Vitória',
  'anchor_task_txt1': 'Visite Velhos Amigos (E Receba Respostas Deles) Por {%s1} Vezes E Ganhe {%s2} 💎',
  'anchor_task_txt2': 'O Número De Sessões Com Novos Usuários > 5 Atinge {%s1} Vezes, Obtenha {%s2} 💎',
  'anniversary.celebration.2.collect': 'Coletar',
  'anniversary.celebration.2.go.look': 'Confira Agora!',
  'anniversary.celebration.2.next.round': 'Próxima Rodada',
  'anniversary.celebration.2.no.time.yet': 'Ainda Não É Hora',
  'anniversary.celebration.2.ok': 'Ok',
  'anniversary.celebration.2.ranking.tab.receive': 'Classificação De Charme',
  'anniversary.celebration.2.ranking.tab.send': 'Classificação De Riqueza',
  'anniversary.celebration.2.rewards.tips': 'Para Detalhes Sobre Como Obter Moedas E Diamantes, Confira A Página De Regras.',
  'anniversary.celebration.2.scene.rewards.desc': 'Depois De Participar Do Desbloqueio Da Cena Atual, Você Pode Obter As Seguintes Recompensas, E O Mvp Tem Recompensas Adicionais.',
  'anniversary.celebration.2.scene.tips': 'O Consumo De Moedas Em Todas As Plataformas (Exceto Partes Do Jogo E Envio De Pacotes Da Sorte) Atinge O Valor Alvo Para Desbloquear Cenas E Obter Recompensas. Envie Presentes Limitados Para Ganhar O Dobro De Pontos!',
  'anniversary.celebration.2.scene.unlock.modal.mvp.tag': 'Mvp Pode Obter',
  'anniversary.celebration.2.scene.unlock.modal.title': 'Parabéns Pela Sua Participação No Desbloqueio Do Local:',
  'anniversary.celebration.2.scene.unlock.modal.you.can.get': 'Pode Obter',
  'anniversary.celebration.2.special.gift.contribution': 'Baú Encantador',
  'anniversary.celebration.2.special.gift.desc': 'Valor De Presente Limitado Acumulado Recebido {%d} Moedas Podem Participar Da Seleção De Estrelas Da Sorte ({%z}/{%m})',
  'anniversary.celebration.2.special.gift.lucky': 'Baú Da Sorte',
  'anniversary.celebration.2.special.gift.title': 'Caixa De Bônus',
  'anniversary.celebration.2.special.gift.to.be.drawn': 'Para Ser Desenhado',
  'anniversary.celebration.2.special.gift.to.complete': 'Conclua Agora',
  'anniversary.celebration.2.tab.ranking': 'Classificação',
  'anniversary.celebration.2.tab.scene': 'Jornada De Celebração',
  'anniversary.celebration.2.waiting': 'Esperando',
  'annual.draw.1.time': 'Empate {N} Vez',
  'annual.draw.10.time': 'Empate {N} Vezes',
  'annual.draw.pop.no.record': 'Nenhum Registro Ainda.',
  'annual.draw.pop.no.times': 'Tempos De Sorteio Insuficientes',
  'annual.draw.pop.oppos': 'Opostos!',
  'annual.draw.pop.rewards.title': 'Felicitar!',
  'annual.draw.pop.to.get': 'Obter',
  'annual.draw.record.text': 'Parabéns! Você Recebeu',
  'annual.ranking.collect': 'Coletar',
  'annual.ranking.confirm': 'Confirmar',
  'annual.ranking.current.tickets': 'Ingressos Atuais',
  'annual.ranking.daily.ranking': 'Classificação Diária',
  'annual.ranking.daily.task': 'Tarefa Diária',
  'annual.ranking.exchange': 'Intercâmbio',
  'annual.ranking.exchange.amount': 'Valor Da Troca',
  'annual.ranking.exchange.maximum': 'O Valor Da Troca Atingiu O Máximo Hoje',
  'annual.ranking.fortune.wheel': 'Roda Da Fortuna',
  'annual.ranking.icon': 'Ícone',
  'annual.ranking.limited': 'Limitado',
  'annual.ranking.num': 'Números',
  'annual.ranking.open': 'Abrir',
  'annual.ranking.points': 'Pontos',
  'annual.ranking.record': 'Registro',
  'annual.ranking.return': 'Retornar',
  'annual.ranking.slod.out': 'Vendido',
  'annual.ranking.stock': 'Estoque',
  'annual.ranking.success': 'Sucesso',
  'annual.ranking.surprise.store': 'Loja Surpresa',
  'annual.ranking.task.confirm': 'Tem Certeza De Que Quer Aproveitar O Modo {$count}x Pontos Agora?',
  'annual.ranking.ticket': 'Bilhete',
  'annual.ranking.to.bag': 'Os Itens Trocados Podem Ser Visualizados Na Bolsa',
  'annual.ranking.total.ranking': 'Classificação Total',
  'annual.ranking.unfinished': 'Inacabado',
  'annual.ranking.union.achor': 'Âncora Anual',
  'annual.ranking.union.agency': 'Agência Anual',
  'annual.ranking.union.id': 'Id Da Agência:',
  'annual.ranking.union.target': 'Alvo',
  'aristocracy.vip.coin.box.sub.title': 'Válido Até',
  'aristocracy.vip.title': 'Aristocracia',
  'biu.biu.building.all.list': 'Classificação Total',
  'biu.biu.building.can.rush.one': 'Tempos De Pico Restantes: Carro De Nível 1*{$times}',
  'biu.biu.building.can.rush.two': 'Carro Nível 2*{$times}',
  'biu.biu.building.car.detail': 'Detalhes Do Veículo',
  'biu.biu.building.car.double': 'Carros',
  'biu.biu.building.car.not.enough': 'O Número Atual De Veículos É Insuficiente',
  'biu.biu.building.car.single': 'Carro',
  'biu.biu.building.congra': 'Parabéns!',
  'biu.biu.building.daily.list': 'Classificação Diária',
  'biu.biu.building.detail.coin': '{$month}-{$day} {$hour}:{$min}, Você Recarregou {$coin} Moedas.',
  'biu.biu.building.detail.floors.one': '{$month}-{$day} {$hour}:{$min}, Você Lutou Contra {$count} {$level} {$cars} E Destruiu {$floornumer} {$floor}.',
  'biu.biu.building.floor.double': 'Pisos',
  'biu.biu.building.floor.single': 'Chão',
  'biu.biu.building.get.reward': 'Sua Recompensa!',
  'biu.biu.building.no.lucky': 'Azarado',
  'biu.biu.building.no.records': 'Nenhum Registro',
  'biu.biu.building.no.start': 'Esta Etapa Está Prestes A Começar',
  'biu.biu.building.one.car': 'Carro Nível 1',
  'biu.biu.building.ranking.list': 'Classificação',
  'biu.biu.building.recharge': 'Recarregue {$value}Moedas/{$count} Vezes',
  'biu.biu.building.ruls.reward': 'Regra E Recompensas',
  'biu.biu.building.rush.button': 'Vá*{$times}',
  'biu.biu.building.to.collect': 'Ok',
  'biu.biu.building.to.get': 'Obter',
  'biu.biu.building.to.war': 'Ir',
  'biu.biu.building.two.car': 'Carro Nível 2',
  'blank': '<p>Nenhum Conteúdo Relacionado<p> <p>Por Favor, Verifique Outros Canais<p>',
  'boring': 'Tedioso',
  'break.through.text.14': 'Parabéns! Você Foi Premiado',
  'call': 'Chamada E Classificação',
  'cancel': 'Cancelar',
  'chatConversation': '💬 Rodadas De Bate-Papo',
  'chatSpeed': 'Velocidade De Resposta',
  'chatSpeed1': 'Minha Velocidade De Resposta Às Mensagens',
  'chat_skill_title': 'Leitura Obrigatória Para Âncoras',
  'chatting': 'Desempenho Do Chat De Mensagens',
  'chatting1': 'Meu Desempenho No Chat',
  'click.refresh': 'Clique Para Atualizar',
  'cms_report_text10': 'Resultado Da Penalidade:',
  'cms_report_text11': 'Histórico De Punições',
  'cms_report_text12': 'Advertência Verbal',
  'cms_report_text13': 'Método De Banimento:',
  'cms_report_text14': 'Motivos Para Banimento:',
  'cms_report_text15': 'Tempo De Proibição:',
  'cms_report_text16': 'Sensibilidade Política',
  'cms_report_text17': 'Vulgar',
  'cms_report_text18': 'Ataque E Abuso',
  'cms_report_text19': 'Violência Sangrenta',
  'cms_report_text20': 'Anúncio',
  'cms_report_text21': 'Suspeita De Fraude',
  'cms_report_text22': 'Informações Ilegais',
  'cms_report_text23': 'Menor',
  'cms_report_text24': 'Outro',
  'cms_report_text25': 'Confirmação',
  'cms_report_text26': 'Operação Sensível À Conta, Confirme As Informações Após As Informações',
  'cms_report_text3': 'Motivo Do Relatório:',
  'cms_report_text4': 'Detalhes Do Relatório:',
  'cms_report_text5': 'Captura De Tela Do Relatório:',
  'cms_report_text6': '*Por Favor, Verifique As Informações Acima Para Que Possamos Aplicar Uma Penalidade Pelas Informações.',
  'cms_report_text7': 'Repórter Showid:',
  'cms_report_text8': 'O Repórter Showid:',
  'cms_report_text9': 'Método De Penalidade:',
  'coin.merchant.amount': 'Quantia:',
  'coin.merchant.change.password': 'Mudar Senha',
  'coin.merchant.chat': 'Conversa',
  'coin.merchant.coins.num': 'Inventário De Moedas:',
  'coin.merchant.confirm.again': 'Confirme A Senha Da Transação Novamente',
  'coin.merchant.confirm.new.again': 'Confirme A Nova Senha Novamente',
  'coin.merchant.der.amount': 'Valor Da Recarga:',
  'coin.merchant.der.another': 'Recarregar Outra Conta',
  'coin.merchant.der.bind.phone': 'Vincular Número De Celular',
  'coin.merchant.der.bind.phone.placeholder': 'Número De Telefone',
  'coin.merchant.der.change.country': 'Selecione O País',
  'coin.merchant.der.channel': 'Método De Pagamento:',
  'coin.merchant.der.channel.tips': 'Caso Não Consiga Concluir O Pagamento Através Dos Seguintes Métodos, Entre Em Contato Pelo Whatsapp Da Equipe Oficial Para Consultar Sobre A Compra:',
  'coin.merchant.der.channel.tips.link': 'Cópia',
  'coin.merchant.der.code.tips': 'Caso Não Consiga Receber O Código De Verificação, Entre Em Contato Pelo Whatsapp Da Equipe Oficial:',
  'coin.merchant.der.complete': 'Recarga Concluída',
  'coin.merchant.der.complete.tips': '{number} Moedas Foram Recarregadas Com Sucesso Para {name}! Faça Login Para Se Divertir Ainda Mais!',
  'coin.merchant.der.current.country': 'Atualmente Utilizando O Canal De Pagamento De',
  'coin.merchant.der.error': '*Nenhum Resultado Encontrado',
  'coin.merchant.der.fail': 'Falha Ao Recarregar',
  'coin.merchant.der.fail.tips': 'Falha Ao Recarregar Sua Conta. Entre Em Contato Conosco Pelo E-Mail: Tt_Support@Molelive.Com Se Tiver Alguma Dúvida!',
  'coin.merchant.der.id': 'Id Do Talktalk',
  'coin.merchant.der.modal.title': 'Método De Pagamento',
  'coin.merchant.der.more': 'Recarregue Mais',
  'coin.merchant.der.name': 'Seu Apelido No Talktalk:',
  'coin.merchant.der.problem': 'Encontrou Problemas?',
  'coin.merchant.der.redeem': 'Resgatar',
  'coin.merchant.der.resend': 'Reenviar',
  'coin.merchant.der.sms.code': 'Digite O Código De Verificação',
  'coin.merchant.der.sms.tips': 'Uma Atividade Anormal Foi Detectada. Para Garantir A Segurança Da Sua Conta, Conclua O Processo De Verificação Abaixo.',
  'coin.merchant.enter': 'Digitar',
  'coin.merchant.enter.amount': 'Digite O Valor',
  'coin.merchant.enter.new.password': 'Digite A Nova Senha',
  'coin.merchant.enter.original.password': 'Digite A Senha Original',
  'coin.merchant.enter.password': 'Digite Sua Senha De Transação',
  'coin.merchant.enter.transaction.password': 'Digite A Senha Da Transação',
  'coin.merchant.enter.user.id': 'Digite O Id Do Usuário',
  'coin.merchant.history': 'História',
  'coin.merchant.history.title': 'Histórico de Operações',
  'coin.merchant.id': 'Eu Ia',
  'coin.merchant.list.desc': 'Transferir Moedas Para Este Usuário É Equivalente A Uma Recarga, O Que Também Aumentará A Experiência Vip.',
  'coin.merchant.list.title': 'Selecione O Valor',
  'coin.merchant.min.input': 'Valor Mínimo 1000',
  'coin.merchant.not.found': 'Usuário Não Encontrado',
  'coin.merchant.password.error': 'Senha Incorreta. Tente Novamente.',
  'coin.merchant.password.tips': 'A Senha Deve Ter Pelo Menos 8 Caracteres E Deve Consistir Em Letras Maiúsculas E Minúsculas E Números.',
  'coin.merchant.recharge.title': 'Recarga de Vendedor de Moedas',
  'coin.merchant.search': 'Investigação',
  'coin.merchant.set.password': 'Defina Sua Senha De Negociação',
  'coin.merchant.success': 'Remessa Bem-Sucedida',
  'coin.merchant.tips': 'Você Está Prestes A Transferir Um Valor Adicional Para O Usuário. Confirme O Nome E A Quantidade De Moedas Novamente. Esta Operação É Irreversível E O Funcionário Não Se Responsabiliza Por Qualquer Operação Incorreta.',
  'coin.merchant.title': 'Vendedor De Moedas',
  'coin.merchant.to': 'Para:',
  'coin.merchant.transfer': 'Transferir',
  'coin.merchant.transfer.coins': 'Transferir Moedas',
  'coin.merchant.user': 'Usuário',
  'coinBack': 'Moedas Devolvidas',
  'coins.battle.draw.drawing.tips': 'Dicas De Desenho',
  'coins.battle.draw.drawing.tips.desc': 'Tempos De Saque Insuficientes! Recarregue Para Obter Mais Vezes Agora!',
  'coins.battle.draw.drawing.tips.recharge.now': 'Recarregue Agora',
  'coins.battle.draw.no.recharge': 'Só Precisa Recarregar {coinToDrawCount} Moedas Pela Primeira Vez.',
  'coins.battle.draw.recharged': 'Recarga Acumulada De {coinToDrawCount} Moedas: Vezes De Saque +1',
  'coins.battle.draw.remain.times': 'Tempos Restantes: {remainTime} Vezes',
  'coins.battle.draw.total.coins': 'Acumulado:<span class=\'num\'>{totalRechargeCoins}</span>Moedas',
  'coins.battle.entry.btn': 'Recarregue {Cointodrawcount} Moedas Para Obter',
  'coins.battle.entry.desc': 'Você Tem Uma Chance De Ganhar Até 1 Milhão De Moedas!',
  'coins.battle.entry.title': 'Benefícios Surpresa',
  'coins.battle.record.complete.task': 'Tarefa Completa {N}',
  'coins.battle.record.head.coins.or.tasks': 'Moedas/Tarefas',
  'coins.battle.record.head.time': 'Tempo',
  'coins.battle.record.tab.draw.record': 'Registro De Sorteio',
  'coins.battle.record.tab.number.of.draws': 'Número De Sorteios',
  'coins.battle.result.get': 'Pegar',
  'coins.battle.result.prize.pool': 'Ganhe {N}% De Moedas Do Prêmio Total',
  'coins.battle.result.title': 'Parabéns!',
  'coins.battle.rules.not.show.again': 'Não Mostre Novamente.',
  'coins.battle.task.completed': 'Concluído',
  'coins.battle.task.go': 'Ir',
  'coins.battle.task.tips': 'Cada Tarefa Que Você Completar Ganha Um Sorteio.',
  'coins.battle.task.title': 'Área De Exibição De Tarefas',
  'coins.battle.time': 'Tempo',
  'coins.battle.times': 'Vezes',
  'common.Cap.Dating': 'Namorando',
  'common.Cap.Top1': 'Top1',
  'common.Cap.Uncompleted': 'Incompleto',
  'common.Collect': 'Coletar',
  'common.EXP': 'Exp',
  'common.cap.Close': 'Fechar',
  'common.cap.Coins': 'Moedas',
  'common.cap.Collect': 'Coletar',
  'common.cap.Collected': 'Coletado',
  'common.cap.Confirm': 'Confirmar',
  'common.cap.Congratulations': 'Parabéns',
  'common.cap.Continue': 'Continuar',
  'common.cap.Countdown': 'Contagem Regressiva',
  'common.cap.Countdown.to.Start': 'Contagem Regressiva Para Começar',
  'common.cap.Customer.Server': 'Atendimento Ao Cliente',
  'common.cap.Day': 'Dia',
  'common.cap.Event.To.Start': 'O Evento Está Prestes A Começar',
  'common.cap.Follow': 'Seguir',
  'common.cap.Go': 'Ir',
  'common.cap.Hour': 'Hora',
  'common.cap.Limited.Gifts': 'Presentes Limitados',
  'common.cap.Min': 'Mínimo',
  'common.cap.No': 'Não',
  'common.cap.Ranking': 'Classificação',
  'common.cap.Ranking.click': 'Clique',
  'common.cap.Ranking.click.text': 'Para Verificar Diferentes Prêmios',
  'common.cap.Recharge': 'Recarregar',
  'common.cap.Record': 'Registro',
  'common.cap.Rewards': 'Recompensas',
  'common.cap.Rights': 'Todos Os Direitos Reservados Pela Soyo',
  'common.cap.Rules': 'Regras',
  'common.cap.Sec': 'Seg',
  'common.cap.Start': 'Começar',
  'common.cap.Success': 'Sucesso',
  'common.cap.Successfully.Collected': 'Coletado Com Sucesso',
  'common.cap.Sure': 'Claro',
  'common.cap.Unfortunately.Yes': 'Infelizmente Sim',
  'common.cap.Waiting': 'Esperando',
  'common.cap.cancel': 'Cancelar',
  'common.cap.confirm': 'Confirmar',
  'common.cap.event.over': 'O Evento Acabou',
  'common.cap.month1': 'Janeiro',
  'common.cap.month10': 'Outubro',
  'common.cap.month11': 'Novembro',
  'common.cap.month12': 'Dezembro',
  'common.cap.month2': 'Fevereiro',
  'common.cap.month3': 'Março',
  'common.cap.month4': 'Abr',
  'common.cap.month5': 'Poderia',
  'common.cap.month6': 'Junho',
  'common.cap.month7': 'Julho',
  'common.cap.month8': 'Agosto',
  'common.cap.month9': 'Setembro',
  'common.cap.my.times': 'Meus Tempos',
  'common.cap.next.round': 'A Próxima Rodada Acontecerá Em Breve…',
  'common.cap.not.remind': 'Sem Mais Lembretes',
  'common.cap.time': 'Tempo',
  'common.cap.times': 'Vezes',
  'common.cap.update': 'Atualize A Versão Para Usar Os Novos Recursos',
  'common.number': 'Número',
  'common.recharge.text': 'Moedas Não São Suficientes. Quer Recarregar?',
  'common.up.DAYS': 'Dias',
  'common.up.HOURS': 'Horas',
  'common.up.MINS': 'Min',
  'common.up.OK': 'Ok',
  'common.up.RECEIVED': 'Encantador',
  'common.up.RULES': 'Regras',
  'common.up.SECS': 'Segundos',
  'commonErr': '<p>Sistema Ocupado,<p><p>Tente Novamente Mais Tarde<p>',
  'confirm': 'Confirmar',
  'count': '🙋‍♀️ Mensagens',
  'coupon_pay_txt2': 'Somente Para {%s}',
  'coupon_pay_txt3': 'Cupom De Moedas {%s}%',
  'coupon_pay_txt4': 'Moedas',
  'cp.list.cur.reward.text': 'Desbloqueie Este Local Para Receber As Seguintes Recompensas.',
  'cp.list.limit.tips': 'Envie Presentes Limitados Para Atingir O Nível Que Pode Desbloquear O Local De Namoro.',
  'cp.list.unlock.contributor': 'Contribuidor De Localização',
  'crazy.bulider.build.all': 'Construir Tudo',
  'crazy.bulider.build.n': 'Tempo De Construção {N}',
  'crazy.bulider.celebrate.desc': 'Parabéns Pela Construção De {N} Andares!',
  'crazy.bulider.click.celebrate': 'Clique Para Comemorar',
  'crazy.bulider.congura': 'Parabéns!',
  'crazy.bulider.daily': 'Classificação Diária',
  'crazy.bulider.daily.top1': 'Top1 Diário',
  'crazy.bulider.floors.n': 'Pisos{N}',
  'crazy.bulider.get.more': 'Ganhe Mais',
  'crazy.bulider.luck.gift.desc': 'Envie Um Presente Da Sorte A Cada {N} Moedas = 1{hammerIcon}',
  'crazy.bulider.lucky.desc': 'Escolha 1 Lucky Box Para Ganhar Bônus!',
  'crazy.bulider.lucky.moment': '⭐️Momento De Sorte⭐️',
  'crazy.bulider.model.rewards.desc': 'Você Foi Premiado',
  'crazy.bulider.ok': 'Ok',
  'crazy.bulider.opps': 'Ops!',
  'crazy.bulider.progress.current': 'Atual:{M}={N}',
  'crazy.bulider.progress.target': 'Alvo:',
  'crazy.bulider.ranking': 'Classificação',
  'crazy.bulider.rewards.tab1': 'Recompensas De Piso',
  'crazy.bulider.rewards.tab2': 'Recompensas De Classificação',
  'crazy.bulider.share': 'Compartilhar',
  'crazy.bulider.share.desc1': 'Você Já Ultrapassou 90% Dos Construtores! Compartilhe Rapidamente A Visualização Atual Com Seus Amigos!',
  'crazy.bulider.share.desc2': '*O Primeiro Compartilhamento Bem-Sucedido No Moment Pode Gerar Recompensas Exclusivas Para Superconstrutores ↓.,',
  'crazy.bulider.share.desc3': '{X} Pessoas Também Começam A Construir Edifícios Ao Ver Seu Momento!',
  'crazy.bulider.share.desc4': 'Obrigado Pela Sua Influência!',
  'crazy.bulider.share.desc5': 'Os Arranha-Céus Estão Sob Meu Controle!',
  'crazy.bulider.share.moment': 'Compartilhe No Momento',
  'crazy.bulider.share.ok': 'Ok',
  'crazy.bulider.share.reward': 'Você Foi Recompensado',
  'crazy.bulider.share.success': 'Sucesso Compartilhado!',
  'crazy.bulider.share.text': '#👷Construtor Maluco🚧#\nSuperpoder Que Afeta O Mundo! 🌏\n{N} Andares Construídos Com Paixão🔥\nClassificação Global: #{Rank} 👑\nÓtima Chance De Construir Seu Próprio Arranha-Céu!🏙',
  'crazy.bulider.status.count': 'Contagem Regressiva',
  'crazy.bulider.status.end': 'O Evento Acabou',
  'crazy.bulider.status.start': 'O Evento Está Prestes A Começar',
  'crazy.bulider.time.not.desc': 'Tempo De Construção Insuficiente!<br/>O Grande Prêmio Está Esperando Por Você!',
  'crazy.bulider.total': 'Classificação Total',
  'crazy.bulider.waiting': 'Esperando',
  'crazybuilder.friends.list': 'Lista De Amigos',
  'crazybuilder.friends.list.text': 'Visitas Diárias Adicionarão ❤️ À Cidade Do Seu Amigo.',
  'crazybuilder.friends.list.visit': 'Visita',
  'crazybuilder.king.record': 'Recorde Histórico',
  'crazybuilder.map.enter': 'Cidade',
  'crazybuilder.map.notify.btn': 'Ok',
  'crazybuilder.map.notify.desc': 'Sua Cidade Ganha Favoritos! Continue Construindo Para Atrair Mais Visitantes!',
  'crazybuilder.map.notify.title': 'Parabéns!',
  'crazybuilder.map.share.btn': 'Compartilhe Agora',
  'crazybuilder.map.share.desc': 'Compartilhe Sua Cidade Prosperidade! Convide Seus Amigos Para Comemorarem Juntos!',
  'crazybuilder.map.share.text': '#👷Construtor Maluco🚧#\nHabilidade Suprema Necessária Para Construir Cidades Da Prosperidade! 👑💪\n{N} Andares Estão Gravados Com Meu Nome - {Takma Ad}.🌃\n{M} Favoritos❤️ Concedidos À Minha Cidade Da Prosperidade⭐️\nBem-Vindos À Minha Cidade Para Ver Nossa Diferença😎',
  'crazybuilder.mine.record': 'Meu Recorde Atual',
  'crazybuilder.reaching.floors': 'Não Pode Ser Compartilhado Até Atingir Os Andares Alvo',
  'crazybuilder.toast.reach': 'Alcance {n} Andares E Compartilhe Sua Conquista De Construção! E Receba As Seguintes Recompensas:',
  'cumulativeMiss': 'Total Perdido',
  'currentCycle': 'Ciclo Atual',
  'cycleDiamonds': 'Diamantes Neste Ciclo',
  'daily': 'Diário',
  'delete_account_web': 'Excluir Conta',
  'delete_account_web1': '1. Abra O Aplicativo E Entre Na Página Principal, Clique No Canto Inferior Direito Para Entrar Na Guia Eu.',
  'delete_account_web2': '2. Clique Em Configurações Depois De Entrar Na Guia Eu.',
  'delete_account_web3': '3. Clique Em Excluir Conta Após Inserir As Configurações.',
  'delete_account_web4': '4. Confirme O Primeiro Passo Para Excluir Permanentemente A Conta.',
  'delete_account_web5': '5. Confirme O Segundo Passo Caso Não Seja Possível Efetuar Login Usando A Mesma Conta.',
  'delete_account_web6': '6. Confirme A Última Etapa Para Excluir Todas As Informações Pessoais Correspondentes.',
  'delete_account_web7': '7. Após Concluir Todos Os Passos Acima, Sua Conta Foi Excluída Com Sucesso, Juntamente Com Todas As Suas Informações Pessoais E Dados Da Conta. Nossa Plataforma Não Manterá Mais Seus Dados Em Nosso Banco De Dados.',
  'delete_account_web_title': 'Prezado Usuário Do Soyou. Obrigado Por Utilizar E Apoiar Nosso Produto. Caso Queira Excluir Sua Conta, Siga Os Seguintes Passos:',
  'details': 'Detalhes de diamantes',
  'diamond.tab.chat': 'Bater Papo',
  'diamond.tab.voice': 'Festa Da Voz',
  'distributionOfDiamondIncome': 'Distribuição De Renda De Diamantes',
  'dream.city.charm': 'Charme',
  'dream.city.charm.rank': 'Charme',
  'dream.city.city.map': 'Mapa Da Cidade',
  'dream.city.current.coins': 'Moedas Atuais',
  'dream.city.current.diamonds': 'Diamantes Atuais',
  'dream.city.go': 'Ir',
  'dream.city.received': 'Parabéns! Você Recebeu',
  'dream.city.rule.reward': 'Regras E Recompensas',
  'dream.city.rules': 'Regras Do Evento',
  'dream.city.supply.reward': 'Recompensas Do Posto De Suprimentos',
  'dream.city.top5': 'Os 5 Melhores Usuários Que Chegarem Ao Posto De Suprimentos No Sonnest Receberão Recompensas De Suprimentos.',
  'dream.city.waiting': 'Esperando',
  'dream.city.wealth': 'Fortuna',
  'dream.city.wealth.rank': 'Fortuna',
  'dream.city.will.get': 'Você Vai Conseguir',
  'efficient_text_10': 'Se Atingiu O Padrão',
  'efficient_text_11': 'Explicar',
  'efficient_text_12': 'Alcançar O Padrão',
  'efficient_text_13': 'Não Atingiu O Padrão',
  'efficient_text_14': 'Se O Tempo No Microfone Durar Até O Dia Seguinte, Será Contado Como O Tempo Do Dia Anterior',
  'efficient_text_15': 'Tempo Fora Do Microfone - Tempo No Microfone <%$Min',
  'efficient_text_16': 'Tempo Fora Do Microfone - Tempo No Microfone> = %$Min',
  'efficient_text_17': '12/1 9:00:00 O Tempo No Microfone Não Atingiu O Padrão, Não Pode Ser Contado Como Tempo Efetivo',
  'efficient_text_18': '12/1 23:00:00 O Tempo No Microfone Continuou Até 12/2 E Durou 90 Minutos Consecutivos, Então É Contado Como Tempo Durante 12/1',
  'efficient_text_19': '2. Dias Efetivos Da Sala',
  'efficient_text_2': 'Tempo Efetivo',
  'efficient_text_20': 'Na Sala De Voz, Todas As Durações Efetivas São Adicionadas Durante O Dia > = %$ Min É Um Dia Efetivo. Quanto Maior O Número De Dias Válidos, Maior A Atividade, E A Taxa De Atividade Afeta Diretamente As Recompensas Que Você Recebe.',
  'efficient_text_21': 'Tempo Efetivo Total',
  'efficient_text_22': '12/1 3 Vezes Ao Microfone Durante O Dia: 15 Min + 35 Min + 90 Min. Como 15 Min Não Atende Ao Padrão, O Tempo Válido = 90 + 35 = 125 Min = 02H 05 Min',
  'efficient_text_23': '12/1 A Duração Válida Do Dia No Total = 02H 05Min> = %$Min, Que É Contado Como Um Dia Válido',
  'efficient_text_24': '3. Tempo No Microfone',
  'efficient_text_25': 'O Tempo No Microfone Deve Ser Efetivo, E O Tempo Efetivo Deve Ser > = %$Min. O Tempo No Microfone Indica Apenas O Tempo De Bate-Papo No Microfone Na Sala. Será Considerado Efetivo Quando O Tempo No Microfone For > = %$Min, Como:',
  'efficient_text_26': '4. Detalhes Dos Dados',
  'efficient_text_27': 'Os Dados Serão Exibidos De Acordo Com O Ciclo Selecionado',
  'efficient_text_28': 'Diamantes',
  'efficient_text_29': 'Bater Papo',
  'efficient_text_30': 'Sala De Voz',
  'efficient_text_31': 'Detalhes',
  'efficient_text_32': 'Data',
  'efficient_text_33': 'Tempo No Microfone',
  'efficient_text_34': 'Tempo De Vigência Da Sala De Voz',
  'efficient_text_35': 'Dias De Vigência Da Sala De Voz',
  'efficient_text_5': 'Dia Efetivo',
  'efficient_text_6': '1. Tempo Válido Na Sala',
  'efficient_text_7': 'Na Sala De Voz, O Tempo No Microfone - O Tempo Fora Do Microfone > = %$ Min É Um Tempo Efetivo No Microfone. Incentivamos A Pessoa No Microfone A Tomar A Iniciativa De Conversar E Interagir Com Bons Amigos Por Um Longo Tempo, Como:',
  'efficient_text_8': 'Tempo No Microfone',
  'efficient_text_9': 'Tempo Fora Do Microfone',
  'exchange_text_1': 'Intercâmbio',
  'exchange_text_10': 'Pegar:',
  'exchange_text_13': 'Saldo De Diamante Insuficiente',
  'exchange_text_14': 'Troca Bem-Sucedida',
  'exchange_text_16': 'A Troca Falhou.',
  'exchange_text_18': 'Excedeu O Limite De Troca.',
  'exchange_text_2': 'Saldo De Moedas',
  'exchange_text_3': 'Saldo De Diamantes',
  'exchange_text_4': 'Troca Personalizada',
  'exchange_text_5': 'Regras De Troca',
  'exchange_text_6': 'Taxa De Câmbio',
  'exchange_text_7': 'Limite De Troca Diário',
  'exchange_text_8': 'Confirmar A Troca?',
  'exchange_text_9': 'Gasto:',
  'family.battle.new.up.need.s': 'Necessidade De Aumento {N}',
  'family.bronze.family': 'Família Bronze',
  'family.diamond.family': 'Família Diamante',
  'family.diamonds.exch': 'Troca De Diamantes',
  'family.division.privilege': 'Divisão E Privilégio De Divisão',
  'family.division.privilege.describe': 'A Divisão É Baseada Na Experiência Mensal, Reiniciando No Primeiro Dia De Cada Mês. A Divisão Pode Evoluir, Manter E Rebaixar. Manter A Classificação Atual Requer Apenas Atingir 100% Da Experiência De Evolução Correspondente.',
  'family.exp.content.title.1': 'Como Obter Exp Familiar?',
  'family.exp.content.title.2': 'Nível De Família E Nível De Privilégio',
  'family.exp.content1.text.1': '10 Moedas',
  'family.exp.content1.text.2': '1 Experiência',
  'family.exp.content1.text.3': '50 Joias',
  'family.exp.content1.text.title.1': 'Membros Da Família Enviam Presentes',
  'family.exp.content1.text.title.2': 'Membros Da Família Recebem Presentes',
  'family.exp.content1.text.title.3': 'Complete As Tarefas Familiares',
  'family.exp.table.title.1': 'Exp',
  'family.exp.table.title.2': 'Membro',
  'family.exp.table.title.3': 'Co-Capitão',
  'family.exp.table.title.4': 'Administrador',
  'family.exp.title': 'Experiência Familiar',
  'family.football.no.tips': 'Não Há Mais Dicas Para A Próxima Vez',
  'family.football.target': 'Moedas Recompensas Alvo',
  'family.golden.family': 'Família Dourada',
  'family.king.family': 'Família King',
  'family.label.chatroom': 'Sala De Bate-Papo Bg',
  'family.label.familyBg': 'Família Bg',
  'family.label.frame': 'Estrutura Familiar',
  'family.label.tag': 'Etiqueta Da Família',
  'family.level.instructions': 'Instruções Para Nível Familiar',
  'family.new.diamonds.exch': 'Distintivo',
  'family.silver.family': 'Família Silver',
  'family.task.captain.task': 'Capitão Tarefa',
  'family.task.cumulative': 'Tarefa Cumulativa',
  'family.task.daily.exp': 'Exp Diária',
  'family.task.exp.describe': 'O Exp Que Você Contribui Para A Família',
  'family.task.family.level': 'O Nível De Família É Baseado Na Experiência Acumulada. Cada Nível Corresponde Ao Seguinte Privilégio.',
  'family.task.interactive': 'Tarefa Interativa',
  'family.task.invite.join': 'Convide Amigos Para Se Juntarem À Família',
  'family.task.monthly.exp': 'Exp Mensal',
  'family.task.others': 'Outros',
  'family.task.rules.first': 'Após Atender Às Condições Do Baú Do Tesouro Da Família, As Recompensas No Baú Do Tesouro Serão Abertas Aleatoriamente.',
  'family.task.rules.four': 'As Recompensas Serão Distribuídas Automaticamente Após A Abertura Do Baú Do Tesouro.',
  'family.task.rules.second': 'Os Membros Que Concluírem A Tarefa Antes Que O Baú Do Tesouro Seja Aberto Receberão Recompensas.',
  'family.task.rules.three': 'Os Itens Serão Distribuídos Para A Sacola Dos Vencedores, E Outras Recompensas, Como Exp Ou Moedas, Serão Distribuídas Para As Contas.',
  'family.task.tips': 'Conclua Tarefas Nos Primeiros 2 Dias Após Entrar Para A Família Para Ganhar O Dobro De Experiência.',
  'family.task.treasure.chest': 'Baú Do Tesouro Da Família',
  'family.task.treasure.unlocked': 'Se O Número De Membros Atingir %S, O Baú Do Tesouro Da Família Será Desbloqueado À 0H Todos Os Dias.',
  'family.task.your.rewards': 'Suas Recompensas',
  'fes.of.sa.catch.btn': 'Pegar ({N})',
  'fes.of.sa.catch.cong.text': 'Não Conseguimos Pegar Cordeiro Desta Vez, Então Lhe Enviamos Os Melhores Votos E Mais Um Presente!',
  'fes.of.sa.catch.cong.title': 'Parabéns!',
  'fes.of.sa.catch.oops': 'Ops...',
  'fes.of.sa.catch.oops.text': 'Não Consegui Receber Recompensas Desta Vez. A Talktalk Lhe Desejou Tudo De Bom! Tente Novamente!',
  'fes.of.sa.catch.suc.text': 'Parabéns! Você Ganhou 1 Cordeiro Grátis!\nCordeiros Grátis Do Lambfold Valem 5 Pontos No Ranking De Cordeiros!',
  'fes.of.sa.catch.suc.title': 'Capturado Com Sucesso!',
  'fes.of.sa.collect.tools': 'Colete Ferramentas Para Assar Cordeiro',
  'fes.of.sa.combine': 'Combinar',
  'fes.of.sa.count': 'X{N}',
  'fes.of.sa.draw': 'Desenhar*{%d}',
  'fes.of.sa.draw.again': 'Desenhar Novamente',
  'fes.of.sa.event.gift': 'Presente De Evento',
  'fes.of.sa.free': 'Livre!',
  'fes.of.sa.lamb.rewards': 'Brinde Da Lambfold',
  'fes.of.sa.lamb.top': 'Pegue Cordeiros De Graça E Ganhe 5 Vezes Mais Pontos De Classificação!',
  'fes.of.sa.not.start': 'O Evento Está Prestes A Começar',
  'fes.of.sa.ok': 'Ok',
  'fes.of.sa.rank.daily': 'Diário',
  'fes.of.sa.rank.tab1': 'Classificação De Cordeiro Assado',
  'fes.of.sa.rank.tab2': 'Classificação De Charme',
  'fes.of.sa.rank.total': 'Total',
  'fes.of.sa.ranking': 'Classificação',
  'fes.of.sa.recharge.btn': 'Recarregar',
  'fes.of.sa.records': 'Registro',
  'fes.of.sa.send.btn': 'Enviar',
  'fes.of.sa.tab1': 'Desafio Do Cordeiro Assado',
  'fes.of.sa.tab2': 'Dobra De Cordeiro Louca',
  'fes.of.sa.ticket.enough': 'Ingressos Insuficientes, Envie Presentes Para Ganhar Mais',
  'fes.of.sa.time': 'Tempo',
  'fes.of.sa.tip.text': 'Você Tem Mais De {N} Cordeiros Para Combinar, Combinar Agora?',
  'fes.of.sa.unlock.btn': 'Enviar Presente Para Desbloquear',
  'fes.of.sa.wait.lock': 'Estar Aberto!',
  'fishing.activity.achievement': 'Conquista',
  'fishing.activity.bomber': 'Bombardeiro',
  'fishing.activity.cap.Date': 'Data',
  'fishing.activity.cap.Records': 'Registros',
  'fishing.activity.cap.Unfinished': 'Inacabado',
  'fishing.activity.cap.no.record.yet': 'Nenhum Registro Ainda.',
  'fishing.activity.catche.single': 'Há Uma Novidade!',
  'fishing.activity.catches.more': 'Há Novas Capturas!',
  'fishing.activity.congrats': 'Parabéns!',
  'fishing.activity.energy': 'Energia',
  'fishing.activity.energy.not': 'O Valor Energético É Insuficiente!',
  'fishing.activity.energy.tips': 'As Tarefas Diárias São Atualizadas Às 00:00, Lembre-Se De Coletar As Recompensas Na Hora Certa!',
  'fishing.activity.fish.ticket.not': 'Cupom Insuficiente!',
  'fishing.activity.fishing.big': 'Sortudo! Conheça O Peixe Grande! Clique Na Vara Para Aumentar A Força De Tração E Atingir O Valor Alvo Para Pegar O Peixe Grande!',
  'fishing.activity.fishnet': 'Rede De Pesca',
  'fishing.activity.gallery': 'Aquário',
  'fishing.activity.gallery.tips': 'Colete Todos Os Tipos De Peixes Para Receber Moedas Generosas!',
  'fishing.activity.get.more': 'Ganhe Mais',
  'fishing.activity.go': 'Ir',
  'fishing.activity.new': 'Novo',
  'fishing.activity.not.time': 'Esta Etapa Está Prestes A Começar',
  'fishing.activity.ok': 'Ok',
  'fishing.activity.put.aquarium': 'Colocado No Aquário',
  'fishing.activity.rank': 'Mestre',
  'fishing.activity.rank.tips': 'As 5 Melhores Estrelas Da Pesca Diariamente Ganham Recompensas Extras!',
  'fishing.activity.records.coupon': 'Cupom',
  'fishing.activity.records.fish': 'Peixe',
  'fishing.activity.records.others': 'Outros',
  'fishing.activity.slipped.away': 'O Peixe Escapou!',
  'fishing.activity.start.fishing': 'Comece A Pescar',
  'fishing.activity.step1': 'Bem-Vindo! Clique Na Vara De Pescar Para Pescar De Graça!',
  'fishing.activity.step10': 'Os Peixes Capturados Em Duplicata Serão Trocados Automaticamente Por Cupons, Que Podem Ser Usados ​​Para Comprar Itens Na Loja!',
  'fishing.activity.step12': 'Volte Amanhã E Ganhe Mais 1 Bomber Grátis!',
  'fishing.activity.step3': 'Conseguir Um Novo Tipo De Peixe Pode Ser Uma Ótima Ideia No Aquário, E Coletar Todos Os Peixes Pode Render Recompensas Valiosas Em Moedas!',
  'fishing.activity.step5': 'Pesque Novamente!',
  'fishing.activity.step8': 'Parabéns Por Ganhar Um Bomber Grátis! Experimente O Poder Do Bomber Agora Mesmo!',
  'fishing.activity.store': 'Loja',
  'fishing.activity.store.buy': 'Comprar',
  'fishing.activity.store.limit': 'Limite:',
  'fishing.activity.store.sold.out': 'Vendido',
  'fishing.activity.try.again': 'Tente Novamente',
  'fishing.activity.you.got': 'Você Foi Premiado:',
  'fission.cancel': 'Cancelar',
  'fission.coins': 'Moedas',
  'fission.relation.by.amount': 'Por Valor',
  'fission.relation.by.time': 'Por Tempo',
  'fission.trouble': 'Você Está Tendo Problemas Para Recarregar?',
  'flowWater': 'Detalhes da moeda',
  'gacha.play.1': 'Abrir',
  'gacha.play.2': 'Vezes',
  'gacha.play.3': 'Tempo',
  'game.king.attack': 'Ataque',
  'game.king.award.time': 'Hora Do Prêmio',
  'game.king.become.nick': 'Parabéns Por {nickname} Se Tornar {Awardname}',
  'game.king.become.self': 'Parabéns Por Se Tornar {Awardname}',
  'game.king.bounds.gold': 'Bônus De Ouro',
  'game.king.brave.dragon.island': 'A Ilha Do Dragão Valente',
  'game.king.cog': 'Parabéns!',
  'game.king.cur.strogest': 'Atual Mais Forte',
  'game.king.current.battle': 'Valor De Batalha Atual',
  'game.king.divide.pool': 'Dividir Pool De Moedas De Ouro*{receiveCoin}',
  'game.king.end.desc': 'Caro Bravo Guerreiro\nParabéns Pela Sua Conquista #{rankings} No Ranking De Guerreiros E Receba As Seguintes Recompensas',
  'game.king.game.king': 'Rei Do Jogo',
  'game.king.get.rewards': 'Ganhe Recompensas',
  'game.king.go.center': 'Caro, Seu Poder De Combate É Insuficiente. Participe Do Jogo Para Obter Poder De Combate.',
  'game.king.king.desc': 'Pontos Para Esta Rodada',
  'game.king.king.model.coin': 'Batalha Pelo Trono: Obtendo Moedas De Ouro {receiveCoin}',
  'game.king.king.model.times': 'Número De Vezes Que Você Foi O Rei Do Jogo Hoje: {amount}',
  'game.king.king.reward': 'Recompensa Do Rei',
  'game.king.last.warrior': 'Guerreiros Do Último Ataque',
  'game.king.lucky.warrior': 'Guerreiro Sortudo',
  'game.king.no': 'Não',
  'game.king.not.reminder': 'Não Há Mais Lembretes',
  'game.king.other.king.rewards': 'Parabéns A {nickname} Por Ser O {Awardname} E Ganhar {receiveCoin} De Ouro!',
  'game.king.prize.pool': 'Prêmio Total',
  'game.king.reminder': 'Lembretes',
  'game.king.reward': 'Recompensas',
  'game.king.reward.name': 'Nome Da Recompensa',
  'game.king.score': 'Pontuação',
  'game.king.self.king.rewards': 'Parabéns Por Ser O {Awardname} E Receber: {receiveCoin} Moedas De Ouro',
  'game.king.spend.attack': 'Se Deve Gastar {N} Poder De Combate Para Atacar',
  'game.king.strongest.warrior': 'Guerreiro Mais Forte',
  'game.king.tab1': 'Controvérsia Do Trono',
  'game.king.tab2': 'Ilha Do Dragão Valente',
  'game.king.unused.battle': 'Pontos De Batalha Não Utilizados',
  'game.king.warrior.dialog.text': 'Parabéns Por Se Tornar {Awardname} Em {time} E Ganhar: {receiveCoin} Moedas De Ouro!',
  'game.king.warrior.ranking': 'Classificação De Guerreiros',
  'game.king.warrior.rewards': 'Recompensas Do Guerreiro',
  'game.king.will.start': 'Prestes A Começar',
  'game.king.yes': 'Sim',
  'game.king.you.is.king': 'Você É O Rei Dos Jogos',
  'game.list.play.now': 'Vá Jogar',
  'game.list.plus.empyt.list': 'Sem Dados',
  'game.list.rewards.coin.reward.tag': 'Atingindo O Valor Limite',
  'game.list.rewards.coin.reward.title': 'Recompensas Em Moedas De Ouro',
  'game.list.rewards.prop.reward.title': 'Recompensas De Adereços',
  'game.task.center.get': 'Pegar',
  'game.task.center.received': 'Recebido',
  'gamecenter_ranking_txt6': 'Ranking da Sorte',
  'gamecenter_ranking_txt7': 'Ganhe Mais De 5000 Moedas No Jogo Para Se Qualificar Para A Tabela De Classificação, Com Os Usuários Qualificados Mais Recentemente Obtendo Uma Classificação Mais Alta.',
  'getDiamondsDay': 'Diamantes Hoje:',
  'getDiamondsMonth': 'Diamantes Deste Mês:',
  'gift.list.plus.up.need': 'Necessidade De Aumento',
  'gift.wall.help.text1': 'Os Presentes Que Excederem {num} Moedas Por Vez Aparecerão No Mural De Presentes',
  'gift.wall.help.text2': 'O Presente Que Tiver Mais Moedas Será Exibido No Primeiro Ranking',
  'gift.wall.help.text3': 'O Registro No Mural De Presentes Será Mantido Por 24 Horas',
  'gift.wall.title': 'Presentes',
  'hot': 'Quente',
  'hungry.ghost.collect': 'Coletar',
  'hungry.ghost.go.look': 'Confira Agora!',
  'hungry.ghost.next.round': 'Próxima Rodada',
  'hungry.ghost.no.time.yet': 'Ainda Não É Hora',
  'hungry.ghost.ok': 'Ok',
  'hungry.ghost.ranking.tab.receive': 'Classificação De Charme',
  'hungry.ghost.ranking.tab.send': 'Classificação De Riqueza',
  'hungry.ghost.rewards.tips': 'Para Detalhes Sobre Como Obter Moedas E Diamantes, Confira A Página De Regras.',
  'hungry.ghost.scene.rewards.desc': 'Depois De Participar Do Desbloqueio Da Cena Atual, Você Pode Obter As Seguintes Recompensas, E O Mvp Tem Recompensas Adicionais.',
  'hungry.ghost.scene.tips': 'Distribua Presentes Limitados No Servidor E Alcance O Número Correspondente De Moedas Para Desbloquear Cenas E Obter Recompensas. Os Mvps Têm Recompensas Adicionais.',
  'hungry.ghost.scene.unlock.modal.mvp.tag': 'Mvp Pode Obter',
  'hungry.ghost.scene.unlock.modal.title': 'Parabéns Pela Sua Participação No Desbloqueio Do Local:',
  'hungry.ghost.scene.unlock.modal.you.can.get': 'Pode Obter',
  'hungry.ghost.special.gift.contribution': 'Baú De Contribuições',
  'hungry.ghost.special.gift.desc': 'Valor De Presente Limitado Acumulado Recebido {%d} Moedas Podem Participar Da Seleção De Estrelas Da Sorte ({%z}/{%m})',
  'hungry.ghost.special.gift.lucky': 'Baú Da Sorte',
  'hungry.ghost.special.gift.title': 'Caixa De Bônus',
  'hungry.ghost.special.gift.to.be.drawn': 'Para Ser Desenhado',
  'hungry.ghost.special.gift.to.complete': 'Conclua Agora',
  'hungry.ghost.tab.ranking': 'Classificação',
  'hungry.ghost.tab.scene': 'Aventura De Halloween',
  'hungry.ghost.waiting': 'Esperando',
  'iftar.congratulations.unlocking': 'Parabéns Pela Sua Participação No Desbloqueio Do Prato:',
  'iftar.daily.ranking': 'Classificação Diária',
  'iftar.reward.target': 'Moedas Recompensas Alvo',
  'iftar.total.ranking': 'Classificação Total',
  'iftar.you.received': 'Você Recebeu:',
  'ios_rechargeguide_txt3': 'Moedas De Volta',
  'ios_rechargeguide_txt4': 'Alegar',
  'iosso_wallet_txt1': 'Mais',
  'iosso_wallet_txt2': 'Dobrar',
  'iosso_wallet_txt7': 'Ele Retornará Para A Carteira Em {%s} Segundos.',
  'iosso_wallet_txt8': 'Volte',
  'jungle.e.Total': 'Total',
  'jungle.e.btn.finish': 'Envie Mais Presentes De Eventos, Compartilhe Mais Moedas>>',
  'jungle.e.btn.finish.anchor': 'Receba Mais Presentes Ativos E Compartilhe Mais Diamantes!',
  'jungle.e.coin.finish': 'Mais Baús De Tesouro Sintéticos, Ganhe Mais Moedas Do Baú De Super Moedas!',
  'jungle.e.coin.finish.anchor': 'Receba Mais Presentes De Eventos E Compartilhe Mais Diamantes!',
  'jungle.e.coin.reach': 'Todos Os Presentes Dos Membros Alcançam {N} Para Desbloquear O Baú De Super Moedas',
  'jungle.e.coin.reach.anchor': 'Desbloqueie O Super Baú Diamante Quando O Número Total De Presentes Recebidos Atingir {N}',
  'jungle.e.coin.rewards': 'Recompensas Crazy Lambfold',
  'jungle.e.collect.desc': 'Colete Chamas Diariamente Para Ganhar Presentes Especiais E Ganhar {N} Vezes Mais Pontos De Classificação De Charme!',
  'jungle.e.collect.title': 'Coleção Flame',
  'jungle.e.combine': 'Combinar',
  'jungle.e.cong.title': 'Parabéns!',
  'jungle.e.daily': 'Diário',
  'jungle.e.day.refresh': 'Atualização Diária Em',
  'jungle.e.divied.coin': 'Atualmente Pode Compartilhar: {N} Moedas',
  'jungle.e.divied.coin.anchor': 'Atualmente Você Pode Compartilhar {N} Diamantes',
  'jungle.e.draw.again': 'Desenhar Novamente',
  'jungle.e.draw.time': 'Desenhar*{%d}',
  'jungle.e.event.gift': 'Presente De Evento',
  'jungle.e.not.start': 'O Evento Está Prestes A Começar',
  'jungle.e.ok': 'Ok',
  'jungle.e.pool.amount': 'Valor Total Do Prêmio',
  'jungle.e.rechrge': 'Recarregar',
  'jungle.e.record': 'Registro',
  'jungle.e.sec.tab1': 'Classificação De Cordeiro Assado',
  'jungle.e.sec.tab2': 'Classificação De Charme',
  'jungle.e.self.last': '{N} Do Anterior',
  'jungle.e.send': 'Enviar',
  'jungle.e.send.lock': 'Envie Mais {N} Moedas Para Desbloquear',
  'jungle.e.send.lock.anchor': 'Receba Mais {N} Presentes Para Desbloquear',
  'jungle.e.tab1': 'Desafio Do Cordeiro Assado',
  'jungle.e.tab2': 'Classificação',
  'jungle.e.tab3': 'Dobra De Cordeiro Louca',
  'jungle.e.target': 'Limiar: {N}',
  'jungle.e.ticket.enough': 'Carta De Aventura Insuficiente, Complete Tarefas Para Obter Mais',
  'jungle.e.time': 'Tempo',
  'jungle.e.times': 'Vezes X{N}',
  'jungle.e.tip.desc': 'Você Tem Mais De {N} Peito Para Sintético, Sintético Agora?',
  'jungle.e.tool.title': 'Colete Ferramentas Para Assar Cordeiro',
  'jungle.e.treasure': 'X{N}',
  'jungle.e.wating.unlocked': 'Quantidade De Prêmios A Serem Desbloqueados',
  'jungle.e.win': 'Ganhar',
  'jungle.e.win.desc': 'Parabéns Por Ganhar Os Seguintes Prêmios',
  'jungle.e.winner.list': 'Lista De Vencedores',
  'kill.monster.congratulations': 'Parabéns!',
  'lasser.bairam.collect': 'Coletar',
  'lasser.bairam.go.look': 'Confira Agora!',
  'lasser.bairam.next.round': 'Próxima Rodada',
  'lasser.bairam.no.time.yet': 'Ainda Não É Hora',
  'lasser.bairam.ok': 'Ok',
  'lasser.bairam.ranking.tab.receive': 'Classificação De Charme',
  'lasser.bairam.ranking.tab.send': 'Classificação De Riqueza',
  'lasser.bairam.rewards.tips': 'Para Detalhes Sobre Como Obter Moedas, Consulte A Página De Regras.',
  'lasser.bairam.scene.rewards.desc': 'Depois De Participar Do Desbloqueio Da Cena Atual, Você Pode Obter As Seguintes Recompensas, E O Mvp Tem Recompensas Adicionais.',
  'lasser.bairam.scene.tips': 'Distribua Presentes Limitados No Servidor E Alcance O Número Correspondente De Moedas Para Desbloquear Cenas E Obter Recompensas. Os Mvps Têm Recompensas Adicionais.',
  'lasser.bairam.scene.unlock.modal.mvp.tag': 'Mvp Pode Obter',
  'lasser.bairam.scene.unlock.modal.title': 'Parabéns Pela Sua Participação No Desbloqueio Do Local:',
  'lasser.bairam.scene.unlock.modal.you.can.get': 'Pode Obter',
  'lasser.bairam.special.gift.contribution': 'Baú De Contribuições',
  'lasser.bairam.special.gift.desc': 'Valor De Presente Limitado Acumulado Recebido {%D} Moedas Podem Participar Da Seleção De Estrelas Da Sorte ({%Z}/{%M})',
  'lasser.bairam.special.gift.lucky': 'Baú Da Sorte Do Eid',
  'lasser.bairam.special.gift.title': 'Caixa De Bônus',
  'lasser.bairam.special.gift.to.be.drawn': 'Para Ser Desenhado',
  'lasser.bairam.special.gift.to.complete': 'Conclua Agora',
  'lasser.bairam.tab.ranking': 'Classificação',
  'lasser.bairam.tab.scene': 'Viagem De Eid Al-Fitr',
  'lasser.bairam.waiting': 'Esperando',
  'level.halo': 'Nível Halo',
  'level.halo.question1.answer1': 'Quanto Maior O Nível, Mais Brilhante O Halo',
  'level.halo.question1.title': 'Benefícios Do Alto Nível',
  'level.halo.question2.answer1': 'Quanto Maior O Nível, Mais Exclusivo O Ícone',
  'level.halo.question2.title': 'Exibição De Ícones De Nível',
  'level.halo.question3.answer1': 'Suba De Nível Para Obter Recompensas Incríveis',
  'level.halo.question3.title': 'Recompensa De Subida De Nível',
  'level.halo.question4.answer1': 'Receba Um Presente No Valor De 1 Moeda E Ganhe 1 Xp.\nQuanto Maior A Xp, Mais Rápida A Melhoria.',
  'level.halo.question4.title': 'Maneiras De Subir De Nível',
  'level.user': 'Nível Do Usuário',
  'level.user.icon': 'Ícone',
  'level.user.level': 'Nível',
  'level.user.question1.answer1': 'Você Receberá Itens Especiais E Recompensas.',
  'level.user.question1.title': 'Benefícios Do Alto Nível',
  'level.user.question2.answer1': 'Converse Na Sala, Jogue E Envie Presentes',
  'level.user.question2.answer2': 'Complete Tarefas Diárias, Ganhe Experiência Para Subir De Nível',
  'level.user.question2.answer7': 'Faça Uma Festa No Quarto',
  'level.user.question2.answer8': 'Enviar Presente Por Moedas',
  'level.user.question2.answer9': 'Complete Tarefas E Ganhe Exp',
  'level.user.question2.title': 'Maneiras De Subir De Nível',
  'level.user.question3.answer1': 'Quanto Maior O Nível, Mais Exclusivo O Ícone',
  'level.user.question3.title': 'Exibição De Ícones De Nível',
  'level.user.question4.answer1': 'Suba De Nível Para Obter Recompensas Incríveis',
  'level.user.question4.title': 'Recompensa De Subida De Nível',
  'level.user.tips': 'À Medida Que Você Continua A Ganhar Pontos De Experiência, Seu Nível Aumentará Gradualmente',
  'level.user.way.up': 'Maneiras De Aumentar Os Pontos De Experiência:',
  'like': 'Como',
  'loading': 'Carregando...',
  'lucky.darw.coin.draw': 'Empate',
  'lucky.darw.coin.more.times': 'Vezes Custará',
  'lucky.darw.coin.more.will.cost': 'Custará',
  'lucky.darw.coin.one.times': 'Custos De Sorteio 1 Vez',
  'lucky.darw.coin.one.times.two': 'Selecione E Clique Em Ir',
  'lucky.darw.end': 'Evento Não Em Andamento',
  'lucky.darw.no.times': 'O Número Atual De Sorteios Não É Suficiente, Vá Para A Sala E Envie Presentes',
  'lucky.darw.number': 'O Número Dos Meus Sorteios',
  'lucky.darw.ranking': 'Classificação Do Sorteio',
  'lucky.darw.reset.time': 'Contagem Regressiva',
  'lucky.darw.ruls.1': 'Envie Presentes Dentro Das Salas De Bate-Papo E Tenha A Chance De Participar Do Sorteio',
  'lucky.darw.ruls.2': 'A Cada 5000 Moedas Em Presentes, Você Ganha 1 Sorteio',
  'lucky.darw.ruls.3': 'Por Exemplo: 50.000 Moedas = 10 Sorteios, 100.000 Moedas = 20 Sorteios. Envie Mais Presentes Para Obter Mais Sorteios.',
  'lucky.darw.ruls.4': 'Se O Dia Terminar E Você Não Usar Seus Sorteios, Todos Os Seus Sorteios Se Tornarão 0 Após O Término Do Evento.',
  'lucky.darw.title': 'Sorteio',
  'lucky.darw.use': 'Ir Para Usar',
  'lucky.draw.confirm': 'Por Favor Confirme',
  'lucky.draw.confirm.success': 'Com Sucesso',
  'lucky.draw.confirm.text': 'Tem Certeza De Que Deseja Gastar O Ticketx{%d} Para Trocar?',
  'lucky.draw.exchange.records': 'Registros',
  'lucky.draw.exchange.records.commodity': 'Mercadoria',
  'lucky.draw.exchange.records.consume': 'Consumir',
  'lucky.draw.exchange.records.time': 'Tempo',
  'lucky.draw.exchange.shop': 'Bilheteria',
  'lucky.draw.exchange.shop.exchange': 'Intercâmbio',
  'lucky.draw.exchange.shop.val': 'Valor Das Moedas {%D}',
  'lucky.draw.may.confirm.text': 'Tem Certeza De Que Deseja Gastar {%s} X{%d} Para Desenhar?',
  'lucky.draw.may.draw.draw.times': 'Desenhar*{%d}',
  'lucky.draw.may.draw.draw.tips': 'Enviar Presentes Limitados Por {%d}Moedas Pode Ter A Chance De Sortear',
  'lucky.draw.may.result.tips': '{%s} Será Usado Para Desbloquear O Quebra-Cabeça',
  'lucky.draw.may.rewards.tips': 'Para Regras Detalhadas Sobre Como Obter As Recompensas, Acesse A Página De Regras',
  'lucky.draw.may.tab.draw': 'Desenho De Mecha',
  'lucky.draw.may.tab.ranking': 'Classificação',
  'lucky.draw.may.tab.vote': 'Estrela Mecha',
  'lucky.draw.may.unlock': 'Desbloquear',
  'lucky.draw.may.unlock.all': 'Obrigado Por Desbloquear Todos Os Quebra-Cabeças, Pegue Todas As Recompensas',
  'lucky.draw.may.unlock.some': 'Parabéns Por Desbloquear {%s}%, Pegue Essas Recompensas～',
  'lucky.draw.may.vote': 'Voto',
  'lucky.draw.may.vote.cur.ranking': 'Classificação Atual:{%d}',
  'lucky.draw.may.vote.please.enter.id': 'Por Favor Insira O Id',
  'lucky.draw.may.vote.search.tips': 'Somente Âncoras Podem Ser Votadas',
  'lucky.draw.may.vote.tips': 'Enviar Presentes Limitados Por {%d} Moedas Pode Obter 1 Ingresso',
  'lucky.draw.may.vote.top3.tips': 'Mais Detalhes Sobre Recompensas Podem Ser Encontrados Na Página De Regras',
  'lucky.draw.may.vote.top3.title': '3 Principais Recompensas',
  'lucky.draw.may.vote.voting.record': 'Histórico De Votação',
  'lucky.draw.may.vote.voting.record.number': 'Número De Votos',
  'lucky.draw.may.vote.voting.record.user': 'Usuário',
  'lucky.draw.my.times': 'Meus Tempos',
  'lucky.draw.rare': 'Cru',
  'lucky.draw.rules.1': 'No Final Do Evento, Os Três Primeiros Colocados Receberão Os Seguintes Prêmios',
  'lucky.draw.rules.2': 'Nota: Ao Final Da Campanha, O Número De Prêmios Não Utilizados Será 0',
  'lucky.draw.tab.ranking': 'Classificação',
  'lucky.packet.1': 'Enviar Pacote De Sorte',
  'lucky.packet.10': '1. Pacote Da Sorte Com Senha\n- Você Precisa Enviar A Senha Para A Sala Para Pegá-Lo.',
  'lucky.packet.11': '2. O Pacote Da Sorte Requer Seguidores\n- Você Precisa Seguir O Remetente Do Pacote Da Sorte Para Obtê-Lo.',
  'lucky.packet.12': 'Problemas Comuns',
  'lucky.packet.13': '1. Quando O Pacote Aciona A Notificação Mundial Ou Quando O Ícone Do Pacote Da Sorte É Exibido, Outras Pessoas Podem Entrar Na Sua Sala Clicando Nele.',
  'lucky.packet.14': '2. Se Você Trancou Seu Quarto, A Notificação E O Ícone Do Mundo Não Aparecerão.',
  'lucky.packet.2': 'Todos Os Usuários Na Sala Podem Enviar E Reivindicar Pacotes Da Sorte',
  'lucky.packet.3': 'Quando Houver Muitos Pacotes Da Sorte Em Uma Sala, Eles Serão Empilhados E Exibidos. Quanto Mais Cedo Os Pacotes Da Sorte Forem Enviados, Mais Serão Exibidos No Topo.',
  'lucky.packet.4': 'Restrições E Condições',
  'lucky.packet.5': '1. Suporta Apenas O Envio De Moedas.',
  'lucky.packet.6': '2.- A Quantidade De Moedas Que Podem Ser Emitidas: 1000~9999999\nA Quantidade Padrão De Moedas É 3000 Moedas.\n- Número De Pessoas Que Podem Ser Emitidas: 5-500\nO Número Padrão É 10 Pessoas',
  'lucky.packet.7': '3. O Valor Per Capita (Quantidade De Moedas/Número De Pessoas) Precisa Ser Maior Ou Igual A 100 Moedas.',
  'lucky.packet.8': '4. Quando O Valor Do Pacote For Maior Que 10.000 Moedas E O Número De Pessoas For Maior Que 10, Uma Notificação Mundial Será Acionada E Um Ícone Especial Será Exibido Na Lista De Salas.',
  'lucky.packet.9': 'Como Jogar',
  'lucky.packet.title': 'Pacote Da Sorte',
  'lucky.recharge.draw.num': 'Meus Bilhetes De Rifa Disponíveis',
  'lucky.recharge.draw.record': 'Veja Meu Histórico De Vitórias',
  'lucky.recharge.draw.start': 'Comece A Loteria',
  'lucky.recharge.hide.info': 'Ocultar Informações Pessoais',
  'lucky.recharge.recharge.done': 'Você Ganhou Todos Os Bilhetes Giratórios',
  'lucky.recharge.recharge.gift.bag': 'Pacote De Recarga',
  'lucky.recharge.recharge.gift.bag.text': 'Recarregue {N} Todos Os Dias Para Obter',
  'lucky.recharge.recharge.gift.bag.text.1': 'Bilhete De Loteria Com Prêmio*1',
  'lucky.recharge.recharge.next': 'Recarregue {N}<Div></Div> Para Ganhar {X} Bilhetes De Loteria',
  'lucky.recharge.recharge.no': 'Bilhetes De Rifa Insuficientes',
  'lucky.recharge.recharged': 'Recarregado',
  'lucky.recharge.tab.grid': 'Pool De Preços Da Fortune',
  'lucky.recharge.tab.wheel': 'Roda Da Fortuna',
  'lucky.recharge.ticket': 'Rifa\nBilhete',
  'lucky.recharge.wheel.tip.text.1': 'Cada Vez Que Você Recarrega Até Um Certo Valor, Você Pode Ganhar Um Bilhete De Loteria, 100% Premiado!',
  'lucky.recharge.wheel.tip.text.2': 'Quanto Mais Sorteios, Maior A Chance De Ganhar O Jackpot!',
  'lucky.vs.camp.Eagle': 'Classificação Da Águia',
  'lucky.vs.camp.Lion': 'Classificação Do Leão',
  'lucky.vs.camp.edit.text.1': 'Acampamento De Mudança',
  'lucky.vs.camp.edit.text.2': 'Tem Certeza De Que Deseja Mudar De Acampamento? Cada Pessoa Só Pode Mudar De Acampamento Uma Vez.',
  'lucky.vs.camp.edit.text.3': 'Sim',
  'lucky.vs.camp.edit.text.4': 'Não',
  'lucky.vs.camp.join': 'Juntar',
  'lucky.vs.camp.me': 'Nosso Acampamento',
  'lucky.vs.camp.opponent': 'Acampamento Do Oponente',
  'lucky.vs.camp.select': 'Seleção De Acampamento',
  'lucky.vs.camp.select.text.1': 'Os 5 Maiores Contribuidores Dos Acampamentos Vencedores Podem Ganhar Moedas Como Recompensa!',
  'lucky.vs.camp.select.text.2': 'De Qual Acampamento Você Quer Participar?',
  'lucky.vs.camp.select.text.3': 'Dicas: Cada Pessoa Só Pode Mudar De Acampamento Uma Vez Durante O Evento.',
  'lucky.vs.ext.text.tip': 'Alcance {N} Moedas Para Obter As Seguintes Recompensas.',
  'lucky.vs.out.tab.left': 'Caixa De Tesouro',
  'lucky.vs.out.tab.right': 'Águia Vs Leão',
  'lucky.vs.reward.extra': 'Bônus Águia Vs Leão',
  'lucky_daily': 'Diário',
  'lucky_faq1': 'Como Jogar',
  'lucky_faq10': '2. Ciclo Estatístico',
  'lucky_faq11': 'Classificação Diária: Dados De 0:00 A 24:00 Todos Os Dias',
  'lucky_faq12': 'Classificação Semanal: Dados De 0:00 De Cada Segunda-Feira Até 24:00 De Domingo',
  'lucky_faq13': '3. Recompensas De Classificação',
  'lucky_faq14': 'Os Dez Primeiros Colocados No Ranking Diário E Semanal Receberão Recompensas Conforme Mostrado Abaixo',
  'lucky_faq15': 'Recompensas De Classificação Diária',
  'lucky_faq16': 'Classificação',
  'lucky_faq17': 'Recompensas De Classificação Semanal',
  'lucky_faq2': 'Regras Do Jogo',
  'lucky_faq3': '1. Depois De Dar Um Presente De Sorte, Você Tem A Chance De Receber De 1 A 1.000 Vezes A Recompensa Em Moedas De Ouro;',
  'lucky_faq4': '2. Quanto Mais Presentes De Sorte Você Enviar Em Combo Ou Lote, Maior A Chance De Ganhar;',
  'lucky_faq5': '3. As Recompensas Em Moedas De Ouro Serão Distribuídas Ao Saldo Da Conta Em Tempo Real, E Os Detalhes Dos Ganhos Poderão Ser Visualizados No Registro De Presentes Da Sorte;',
  'lucky_faq6': '4. Toda Vez Que Um Presente De Sorte For Dado, A Âncora Também Receberá Uma Certa Proporção De Diamantes.',
  'lucky_faq7': 'Regras de Ranking',
  'lucky_faq8': '1. Regras Estatísticas',
  'lucky_faq9': 'Os Dez Usuários Que Gastarem Mais Moedas De Ouro Participando Do Jogo Diário E Semanal Estarão No Ranking Dos Ricos, E Os Dez Usuários Com Os Maiores Múltiplos De Vitórias Estarão No Ranking Da Sorte.',
  'lucky_list': 'Ranking da Sorte',
  'lucky_weekly': 'Semanalmente',
  'miss': 'Perdas',
  'missToday': 'Perdido-Hoje',
  'modalBtn': 'Continuar A Conversar',
  'modalIncome': 'Taxa De Renda',
  'modalReward': 'Recompensas Extras',
  'modalRound': 'Rodadas De Bate-Papo',
  'modalSpeed': 'Velocidade De Resposta',
  'modalTips': 'Quanto Mais Rápido Você Responder Às Mensagens, Melhor Será A Experiência Do Usuário E Mais Diamantes Você Ganhará.',
  'modalTipsTwo': 'Quanto Maior A Qualidade Do Conteúdo Da Sua Resposta E Mais Rodadas De Bate-Papo, Melhor Será A Experiência Do Usuário E Mais Diamantes Você Ganhará:',
  'modalTipsThree': 'Quanto maior a qualidade das suas respostas, mais diamantes você ganha. Limite diário de recompensas extras: {%s}',
  'month': 'Mês',
  'month.select': 'Selecione O Mês',
  'month.select.day': 'Selecione A Data',
  'more': 'Mais',
  'my.earning.daimonds': 'Diamantes',
  'my.earning.salary.rules': 'Regras De Salário',
  'my.earning.tips': 'Equilíbrio De Diamante',
  'my.earning.title': 'Meus Ganhos',
  'my.earning.withdrawal.rules': 'Regras De Retirada',
  'new.ranking.list.charm': 'Charme',
  'new.ranking.list.contribution': 'Contribuição',
  'new.ranking.list.record': 'Registro',
  'new.task.done': 'Feito',
  'new.task.go': 'Ir',
  'noble_introduce_1': '1. O Que É Aristocracia?',
  'noble_introduce_2': '2.Como Se Tornar Um Aristocrata',
  'noble_introduce_3': '3. Cálculo Do Período De Validade',
  'noble_introduce_4': '4. Instruções Diárias De Entrega De Moedas',
  'noble_introduce_5': '5. Descontos De Compra Contínua',
  'noble_introduce_6': '6. Modernização Da Aristocracia',
  'noble_introduce_7': '7. Enviando A Aristocracia Como Um Presente',
  'noble_introduce_text1': 'A Aristocracia É Um Símbolo De Status Especial E É Dividida Em Sete Níveis De Status: Cavaleiro, Barão, Visconde, Conde, Marquês, Duque E Rei. Diferentes Níveis De Aristocracia Desfrutam De Diferentes Privilégios.',
  'noble_introduce_text2': 'Aristocracia Pode Ser Adquirida Recarregando Moedas De Ouro, E A Compra Pode Ser Concluída Selecionando O Nível Correspondente Na Página Aristocracia. Ao Mesmo Tempo, Você Também Pode Obter Status Aristocrático Por Meio De Presentes De Outras Pessoas.',
  'noble_introduce_text3': 'O Status Aristocrático É Válido Por 30 Dias A Partir Da Data Da Compra, E Você Desfrutará De Privilégios Aristocráticos Durante O Período De Validade. Os Privilégios Expirarão Ao Final Do Período De Validade.',
  'noble_introduce_text4': 'Após Comprar Aristocracia Com Moedas De Ouro, Você Poderá Receber Moedas De Ouro De Presente Todos Os Dias. Você Receberá Moedas De Ouro Diariamente Após Fazer Login. Se Não Fizer Login Naquele Dia, Não Poderá Obter As Moedas De Ouro Daquele Dia. Ao Presentear Aristocracia Com Outras Pessoas, O Destinatário Terá O Direito De Receber Moedas Diárias.',
  'noble_introduce_text5': 'Durante O Período De Obtenção Do Status Aristocrático, E Dentro De 10 Dias Após O Vencimento Do Status Aristocrático, O Mesmo Status Aristocrático Poderá Ser Adquirido Novamente A Um Preço Mais Favorável. Este Plano Não É Automático E Requer Que Você O Adquira Manualmente Para Entrar Em Vigor.',
  'noble_introduce_text6': 'Se Você Já Possui O Status Aristocrático, Pode Comprar Uma Aristocracia De Nível Superior E Obter Diretamente Os Benefícios Mais Recentes. Os Dias Restantes Da Aristocracia Existente Serão Incorporados Ao Nível Mais Recente De Acordo Com O Valor Restante, E O Período De Validade Do Novo Nível Aristocrático Será Estendido.',
  'noble_introduce_text7': 'Ao Conceder Aristocracia A Outra Pessoa, O Preço Original Será Repassado A Ela, E O Destinatário Desfrutará De Moedas Diárias E Outros Direitos Correspondentes Ao Nível. Se O Destinatário Já Possuir Status Aristocrático, Ele Desfrutará Diretamente Do Status Aristocrático De Alto Nível, E Os Demais Níveis Serão Convertidos De Acordo Com A Duração Correspondente.',
  'noble_introduce_title': 'Introdução Às Regras Da Aristocracia',
  'noble_introduce_welcome': 'Bem-Vindo Ao Nosso Sistema Aristocrático! Tornar-Se Um Aristocrata Permitirá Que Você Desfrute De Privilégios E Benefícios Ainda Mais Exclusivos. A Seguir, Uma Introdução Útil Ao Nosso Sistema Aristocrático:',
  'payment_bind_1': 'Conta',
  'payment_bind_10': 'Exclusão Bem-Sucedida',
  'payment_bind_11': 'Primeiro Nome/Nome Próprio',
  'payment_bind_12': 'Sobrenome/Sobrenome',
  'payment_bind_13': 'Endereço Do Contrato',
  'payment_bind_14': 'E-Mail Epay',
  'payment_bind_15': 'Nota: Protocolo Trc-20',
  'payment_bind_16': 'Observação: Certifique-Se De Que Sua Conta Epay Esteja Verificada',
  'payment_bind_17': 'O Endereço Do Contrato Começa Com T',
  'payment_bind_18': 'Não Pode Exceder 40 Caracteres',
  'payment_bind_19': 'Deve Corresponder Ao E-Mail Da Sua Conta Epay',
  'payment_bind_2': 'Cartão Bancário',
  'payment_bind_20': 'Digite O Endereço De E-Mail',
  'payment_bind_21': 'Conta Gcash',
  'payment_bind_22': 'Deve Ter 11 Dígitos Começando Com 09',
  'payment_bind_23': 'Permita Apenas Letras Do Alfabeto Inglês, Espaços, Hifens (-), Pontos (.) E Vírgulas (,) E Menos De 100 Caracteres.',
  'payment_bind_24': 'Conta De Transferência Bancária',
  'payment_bind_25': 'Pix Key',
  'payment_bind_26': 'Documento',
  'payment_bind_27': 'Apenas 11 dígitos são permitidos',
  'payment_bind_2_GPAY': 'Cartão Bancário',
  'payment_bind_3': 'Nome Do Banco',
  'payment_bind_4': 'Nome',
  'payment_bind_5': 'Correspondência',
  'payment_bind_6': 'Endereço',
  'payment_bind_7': '10 Dígitos Ou Pl Mais 10 Dígitos',
  'payment_bind_8': 'Começa Com Tr + 24 Dígitos',
  'payment_bind_9': '{n} Deve',
  'profit': 'Estatísticas De Renda',
  'program_faq_10': 'Todos Na Sala Podem Acessar A Programação Clicando No Canto Superior Direito E Mostrar Apoio Aos Seus Programas Favoritos Clicando Em \"Interessado\" Ou \"Enviar Presente\" Para Aumentar A Popularidade Do Programa.',
  'program_faq_11': 'Excluir Um Programa Ou Fechar A Programação.',
  'program_faq_12': 'O Proprietário Ou Administrador Da Sala Pode Deslizar Para A Esquerda Em Um Programa E Clicar Em \"Excluir\" Para Removê-Lo. A Programação Será Fechada Automaticamente Após 7 Dias, Mas O Anfitrião Ou Administrador Também Pode Fechá-La Manualmente. Excluir Um Programa Ou Fechar A Programação Limpará Os Dados De Popularidade Do Programa.',
  'program_faq_13': 'Pontas',
  'program_faq_13_ios': 'Pontas',
  'program_faq_14': '1. A Programação Permite A Adição De No Máximo 15 Programas.',
  'program_faq_15': '2. Uma Programação Que Não Foi Aprovada Na Revisão Não Pode Ser Aberta.',
  'program_faq_16': '3. A Programação Será Encerrada Automaticamente Após 7 Dias De Sua Abertura.',
  'program_faq_2': 'Introdução Ao Cronograma Do Programa',
  'program_faq_3': 'Para Aumentar A Diversão E A Interatividade, Disponibilizamos Um Recurso De Programação. A Programação Serve Como Uma Prévia Dos Próximos Programas Da Sala. Os Espectadores Podem Votar E Enviar Presentes Com Base Na Programação, Expressando Suas Preferências E Entusiasmo Pelos Programas Da Sala.',
  'program_faq_4': 'Programação Horário Entrada',
  'program_faq_5': 'O Proprietário Ou Administrador Da Sala Pode Acessar A Programação Através Do Menu Configurações. Os Espectadores Podem Acessar A Programação Clicando No Canto Superior Direito Da Sala Quando O Programa Estiver Ao Vivo.',
  'program_faq_6': 'Como Montar Um Cronograma De Programação',
  'program_faq_7': 'Clique Em \"Adicionar Programa\" E Digite O Nome Do Programa Que Você Deseja Executar.',
  'program_faq_8': 'Após Criar E Revisar A Programação, Clique Em \"Iniciar Programação\" Para Torná-La Visível Ao Público. Uma Vez Ativada, Os Espectadores Poderão Ver A Programação.',
  'program_faq_9': 'Como Interagir Com A Programação',
  'program_faq_part1': 'Parte 1',
  'program_faq_part2': 'Parte 2',
  'program_faq_part3': 'Parte 3',
  'program_faq_part4': 'Parte 4',
  'program_list_24_ios': 'Excluir',
  'pull.refresh.activate': 'Solte Para Atualizar',
  'pull.refresh.deactivate': 'Puxe Para Atualizar',
  'pull.refresh.release': 'Carregando Mais',
  'push.refresh.activate': 'Carregando Mais',
  'push.refresh.noMore': 'Sem Mais Informações',
  'quality': 'Qualidade Do Bate-Papo',
  'quickCall': 'Avaliações Do Usuário <br /> Para Chamada Rápida Com A Âncora',
  'quickCall1': 'Avaliações De Usuários <br /> Para Chamada Rápida Comigo',
  'ramadan.new.back': 'Voltar',
  'ramadan.new.bottom.desc': 'Recarregue Uma Vez Por Dia E Você Pode Assinar Novamente Uma Vez',
  'ramadan.new.collect': 'Coletar',
  'ramadan.new.collected': 'Coletado',
  'ramadan.new.estimated.win': 'Vitória Estimada',
  'ramadan.new.event.start': 'O Evento Está Prestes A Começar',
  'ramadan.new.had.sign': 'Você Fez Login Novamente Hoje.',
  'ramadan.new.honor.countdown.ing': 'Contagem Regressiva',
  'ramadan.new.honor.countdown.over': 'O Evento Acabou',
  'ramadan.new.honor.countdown.waiting': 'O Evento Está Prestes A Começar',
  'ramadan.new.honor.desc': 'O Pop-Up De Honra Da Sala Será Acionado Uma Vez Para Cada {N} Presentes Limitados Em Todas As Plataformas.',
  'ramadan.new.honor.my.times': 'Meus Tempos',
  'ramadan.new.honor.time': '{N}Tempo',
  'ramadan.new.honor.times': '{N}Vezes',
  'ramadan.new.honor.toTop1.time': 'Precisa De <span class=\'span\'> {N} </span> Tempo',
  'ramadan.new.honor.toTop1.times': 'Necessidade De <span class=\'span\'> {N} </span> Vezes',
  'ramadan.new.my.tickets': 'Meus Ingressos',
  'ramadan.new.next': 'Próximo',
  'ramadan.new.nickname': 'Apelido',
  'ramadan.new.not.remain': 'Não Mostre Novamente.',
  'ramadan.new.ok': 'Ok',
  'ramadan.new.prize.content': 'Você Recebeu',
  'ramadan.new.rank.daily': 'Classificação Diária',
  'ramadan.new.rank.daily.desc': 'Usuários Top1 Diários Podem Receber Recompensas Correspondentes.',
  'ramadan.new.rank.tab.give': 'Classificação De Riqueza',
  'ramadan.new.rank.tab.receive': 'Classificação Encantadora',
  'ramadan.new.rank.tips': 'Esta Etapa Está Prestes A Começar',
  'ramadan.new.rank.total': 'Classificação Total',
  'ramadan.new.resign.btn': 'Reinicie Sessão',
  'ramadan.new.resign.content': 'A Renovação Bem-Sucedida Obtém:',
  'ramadan.new.resign.fail.btn': 'Recarregue Agora',
  'ramadan.new.resign.fail.content': 'Recarregue Uma Vez Por Dia E Você Pode Assinar Novamente Uma Vez. (Moedas Compradas De Revendedores Serão Contadas; Compras Na Plataforma Por Revendedores Não Serão Contadas.)',
  'ramadan.new.sign.day': 'Faça Login Por {N} Dias',
  'ramadan.new.tab1': 'Login Para O Ramadã',
  'ramadan.new.tab2': 'Classificação De Oração',
  'ramadan.new.tab3': 'Bênção Honra',
  'ramadan.new.today.content': 'Faça Login Hoje Para Obter:',
  'ramadan.new.waiting': 'Esperando',
  'ranking.blank.daily': 'Ninguém Enviou Presentes Hoje',
  'ranking.blank.weekly': 'Ninguém Enviou Presentes Esta Semana',
  'ranking.contributed': 'Contribuiu:',
  'ranking.daily': 'Diário',
  'ranking.weekly': 'Semanalmente',
  're_signing': 'Re-Assinando',
  'reached': '🙋‍♀️ Número De Usuários',
  'recharge.event.Recharge': 'Recarregar',
  'recharge.event.amount.reached': 'Quantidade De Moedas Alcançada',
  'recharge.event.done': 'Parabéns! Você Atingiu O Nível Mais Alto! Aproveite Suas Recompensas Agora!',
  'recharge.event.group': 'Grupo',
  'recharge.event.hidden': 'Ocultar Informações',
  'recharge.event.next.1': 'Só Preciso',
  'recharge.event.next.2': 'Moedas Para Chegar Ao Próximo Nível',
  'recharge.event.ranking.list': 'Lista De Classificação',
  'recharge.event.rewards.for': 'Recompensas Para',
  'recharge.event.tab.1': 'Progresso Da Recarga',
  'recharge.event.trouble': 'Você Está Tendo Problemas Para Recarregar?',
  'recharge.result.pending': 'Operação Concluída',
  'recharge.result.tips': 'Se As Moedas Não Chegarem A Tempo, Não Se Preocupe, Pode Haver Atrasos Na Rede. Em Caso De Dúvidas, Entre Em Contato Com O Atendimento Ao Cliente Oficial Da Soyou.',
  'recharge.result.tips.click': 'Clique Para Retornar Ao App',
  'retry': 'Tentar Novamente',
  'rich_list': 'Classificação Rica',
  'roundTitle': 'Regras De Renda Das Rodadas De Bate-Papo',
  'share.download': 'Download',
  'share.install': 'Instale O Aplicativo Soundi Radio Agora',
  'share.live': 'Ao Vivo',
  'share.ok': 'Ok',
  'share.play': 'Toque Na Rádio Soundi',
  'share.whatsapp.tip': 'O Whatsapp Pode Não Estar Instalado No Seu Telefone, Instale-O E Tente Novamente.',
  'share_text100': 'Copiado',
  'share_text23': 'Download',
  'share_text24': 'Entre Na Sala',
  'share_text25': 'Estou Nesta Sala, Venha E Junte-Se A Nós',
  'share_text26': 'Id Da Sala',
  'sign_in_text3_new': 'Faça Login E Ganhe O Dobro Da Recompensa',
  'speed': 'Velocidade De Resposta',
  'speed.passion.Completed': 'Concluído',
  'speed.passion.Daily.Rewards': 'Recompensas Diárias',
  'speed.passion.Done': 'Feito',
  'speed.passion.Result': 'Resultado',
  'speed.passion.Result.lose': 'Nenhum Time Venceu Ontem, Então Vamos Tentar Novamente Hoje.',
  'speed.passion.Result.ps': 'Ps: Somente O Mvp Do Grupo Vencedor Ganhará Recompensas Extras!',
  'speed.passion.Result.win': 'Parabéns Ao {N} De Ontem Por Ter Ficado Em Primeiro, Ganhe Essas Recompensas!',
  'speed.passion.change': 'Mudar',
  'speed.passion.change.change.desc': 'Tem Certeza De Que Deseja Mudar Para Este Grupo?',
  'speed.passion.change.change.group': 'Alterar O Grupo',
  'speed.passion.change.change.ps': 'Ps: Todas As Recompensas Deste Grupo Ficarão Indisponíveis Após A Mudança De Grupo.',
  'speed.passion.choice.group': 'Selecione O Grupo',
  'speed.passion.choice.group.desc': 'Obtido Após Ingressar No Grupo',
  'speed.passion.daily.task': 'Tarefa Diária',
  'speed.passion.go.for.it': 'Vá Em Frente',
  'speed.passion.limited.desc': 'Usuários Nomeados Ganham {N}X Milhas Ao Enviar Seus Presentes Nomeados',
  'speed.passion.naming.desc': 'O Usuário Que Enviar Este Presente Com Mais Frequência Durante O Evento Receberá Este Presente Na Semana Seguinte!',
  'speed.passion.naming.progress': 'Progresso Nomeado',
  'speed.passion.naming.progress.get.the.number': 'Pegue O Número',
  'speed.passion.naming.progress.no.one.get': 'Ninguém Tem Acesso A Ele Ainda, Então Participe!',
  'speed.passion.naming.unnamed': 'Sem Nome',
  'speed.passion.race': 'Uma Corrida',
  'speed.passion.rank.Mileage': 'Quilometragem:',
  'speed.passion.rank.daily': 'Diário',
  'speed.passion.rank.no.rank': 'Meu Grupo',
  'speed.passion.rank.not.time': 'Ainda Não É Hora.',
  'speed.passion.rank.total': 'Total',
  'speed.passion.ranking': 'Classificação',
  'speed.passion.winning.TOP1': 'Vencedor Do Top1',
  'speedTitle': 'Regras De Renda Para Resposta À Mensagem',
  'spring.cp.cruise.bless': 'Clique Para Abençoar',
  'spring.cp.cruise.bless.click.desc': 'Clique Em {N} Vezes Para Obter {name} {time}',
  'spring.cp.cruise.bless.my.times': 'Meus Tempos',
  'spring.cp.cruise.bless.status.1': 'Recebido',
  'spring.cp.cruise.bless.status.2': 'Não Reclamado',
  'spring.cp.cruise.find.my.cp': 'Encontre Meu Cp',
  'spring.cp.cruise.my.cp': 'Meu Cp',
  'spring.cp.cruise.rule.tips': 'O Cp Que Receber Mais Rosas Enviando Presentes Limitados Uns Aos Outros Durante O Evento Poderá Organizar Um Casamento Em Um Cruzeiro No Dia 14/02.',
  'spring.cp.no.cp': 'Você Não Enviou Um Presente Limitado',
  'spring.cp.no.people': 'Esperando',
  'spring.cp.rewards.wedding.tips': 'Os Dois Usuários Que Estão Hospedando O Casamento Podem Obter O Avater Limitado*30 Dias',
  'spring.cp.tab.cruise.ranking': 'Casamento Em Cruzeiro',
  'spring.cp.tab.rose.ranking': 'Classificação De Rosas',
  'spring.cp.tab.rose.ranking.daily': 'Classificação Diária',
  'spring.cp.tab.rose.ranking.daily.tips': 'Enviar Este Presente Pode Render {%D}% Rosas Extras Hoje',
  'spring.cp.tab.rose.ranking.daily.toast': 'A Data Não Chegou',
  'spring.cp.tab.rose.ranking.total': 'Classificação Total',
  'spring.cp.wait.wedding': 'O Casamento Começa Em 14 De Fevereiro',
  'svip_introduce_1': '1. O Que É Svip',
  'svip_introduce_2': '2. Como Se Tornar Um Svip',
  'svip_introduce_3': '3. Como Calcular O Período De Validade Do Svip',
  'svip_introduce_4': '4. Rebaixamento E Rebaixamento Do Svip',
  'svip_introduce_5': '5. Direitos E Interesses Do Svip',
  'svip_introduce_text1': 'Svip É O Sistema De Níveis Diferenciados Da Plataforma. Há 8 Níveis No Total, Svip1 A Svip8. Quanto Maior O Nível, Mais Diferenciado Será O Status E Mais Direitos E Interesses Avançados Você Terá.',
  'svip_introduce_text2': 'Você Pode Obter Pontos De Experiência Svip Recarregando Moedas De Ouro. 1 Moeda De Ouro = 1 Ponto De Experiência. Quando Os Pontos De Experiência Atingirem Diferentes Níveis De Svip, Você Poderá Obter O Nível De Svip Correspondente.',
  'svip_introduce_text31': 'O Svip Considera Cada Mês Natural Como Um Ciclo E, No Primeiro Dia De Cada Mês Natural, Os Pontos De Experiência Svip São Acumulados A Partir De 0. O Nível Svip Correspondente Será Obtido De Acordo Com O Nível Alcançado Pelo Valor De Experiência Svip.',
  'svip_introduce_text32': 'A Partir Do Momento Em Que Você Obtiver O Status Svip, Seu Status E Privilégios Serão Mantidos Até O Final Do Mês Seguinte. (Por Exemplo: Se O Svip3 For Alcançado Em 18 De Maio, O Status Svip3 Será Estendido Até 30 De Junho.)',
  'svip_introduce_text33': 'Se O Seu Valor De Experiência Svip Atingir Um Nível Mais Alto Dentro De Um Mês Normal, Ele Será Atualizado Imediatamente. (Por Exemplo: Se Você Atingir O Svip3 Em 18 De Maio E O Svip4 Em 25 De Maio, Você Obterá O Status Svip4 Imediatamente Em 25 De Maio E Continuará Até O Final De 30 De Junho.)',
  'svip_introduce_text34': 'Quando O Mês Natural Terminar, A Identidade E Os Privilégios Serão Mantidos, Mas Os Pontos De Experiência Svip Para O Próximo Mês Serão Acumulados A Partir De 0. (Por Exemplo: Se Você Atingir Svip4 Em 25 De Maio, Você Ainda Desfrutará Da Identidade E Dos Direitos De Svip4 Durante Todo O Mês De Junho, Mas Começará A Acumular Pontos De Experiência Svip A Partir De 0 Em Junho)',
  'svip_introduce_text41': 'No Início De Cada Mês Natural, Se Você Tiver Um Nível Svip E Quiser Mantê-Lo No Mês Seguinte, Precisará Atingir 50% Do Valor De Experiência Do Nível Svip Antes Do Final Do Mês Natural, Ou Seja, Poderá Manter Esse Nível No Mês Seguinte, Mantendo A Identidade E Os Direitos. (Por Exemplo: Quando Maio Começa, Você É Svip4, Então Você Só Precisa Atingir 50% Do Valor De Experiência Do Nível Svip4 Ao Longo De Maio Para Manter O Nível Svip4 Até O Final De Junho.)',
  'svip_introduce_text42': 'Se 50% Do Valor De Experiência Do Nível Svip Não For Atingido Em Um Mês Natural, Ele Será Reduzido Em 1 Nível No Mês Seguinte. (Por Exemplo: No Início De Maio, Você É Svip4 E O Valor De Experiência Em Todo O Mês De Maio Não Atinge 50% Do Nível Svip4, Então Junho Cairá Em 1 Nível, Começando No Svip3.)',
  'svip_introduce_text43': 'Se Nenhum Ponto De Experiência Svip For Gerado Dentro De Um Mês Natural, O Nível Svip Cairá 3 Níveis No Mês Seguinte. (Por Exemplo: Quando Maio Começa, Você É Svip4 E Nenhum Ponto De Experiência É Gerado Durante Maio, Então Junho Cairá 3 Níveis, Começando No Svip1)',
  'svip_introduce_text5': 'Quanto Maior O Nível Svip, Mais Direitos Você Terá. Ao Mudar De Nível, Você Desfrutará Dos Benefícios Do Novo Nível, E As Recompensas De Adereços Recebidas Serão Substituídas Pelo Novo Nível. Ao Atualizar Ou Manter Adereços Personalizados, Você Precisa Entrar Em Contato Com O Atendimento Ao Cliente E Informar Os Requisitos De Personalização Antes Que Eles Sejam Emitidos. No Entanto, Eles Não Serão Emitidos Se Você Fizer O Downgrade.',
  'svip_introduce_title': 'Introdução Às Regras Svip',
  'svip_introduce_welcome': 'Bem-Vindo Ao Svip! O Svip Permitirá Que Você Desfrute De Mais Privilégios. A Seguir, Uma Introdução Útil Ao Svip:',
  'svip_table1': 'Nível Svip',
  'svip_table2': 'Mensagem Grátis',
  'svip_table3': 'Chamadas Gratuitas',
  'task.center.common.level': 'Nível',
  'task.center.limit.Diamonds.Received': 'Diamantes Recebidos',
  'task.center.limit.Reward.Received': 'Recompensa Recebida',
  'task.center.limit.Total': 'Total',
  'task.center.limit.extra': 'Extra',
  'task.center.limit.receive': 'Receber',
  'task.center.limit.task': 'Tarefa Limitada',
  'task.center.limit.to.start': 'O Evento Ainda Não Começou',
  'task.center.limit.today': 'Hoje',
  'task.center.normal.task': 'Tarefa Normal',
  'task.center.title': 'Centro De Tarefas',
  'task_miss': 'Perder',
  'task_txt21': 'Check-In Diário',
  'task_txt22': 'Dia',
  'task_txt23': 'Entrar',
  'task_txt24': 'Lista De Tarefas',
  'task_txt25': 'Tarefas De Âncora',
  'task_txt31': 'Assinado Em',
  'tips': 'Não Há Mais Dados',
  'to.exchange.page.button': 'Intercâmbio',
  'total.rank.daily': 'Diário',
  'total.rank.day': 'Diário',
  'total.rank.gap': 'Lacuna {X}',
  'total.rank.gift': 'Estrela<br />Semanal',
  'total.rank.help': '<h1>Tipo De Classificação<h1>\n<p>Classificação &lt;Sala&gt;: Durante O Período, Todos Os Quartos Serão Classificados De Acordo Com A Quantidade De Moedas Enviadas Como Presentes.</p>\n<p>Classificação &lt;Doador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Enviadas Como Presentes.</p>\n<p>Classificação &lt;Encantador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Recebidas Como Presentes.</p>\n<h1>Ciclo De Tempo Da Classificação</h1>\n<p>O Ciclo De Classificação Geralmente Dura Horas, Dias, Semanas E Meses.</p>\n<p>A Classificação Mostra Os 3 Melhores Do Ciclo Anterior, Bem Como Os 50 Melhores Do Ciclo Atual, Atualizados Em Tempo Real.\n(Com Um Atraso De Menos De 1 Minuto)</p>\n<p>Horário De Atualização (Utc+3): Atualização Diária Da Classificação Às 5H; Atualização Semanal Da Classificação Às 5H De Cada Segunda-Feira; Atualização Mensal Da Classificação Às 5H Do Dia 1º De Cada Mês.</p>\n<h1>Proteção De Privacidade</h1>\n<p>Algumas Classificações Não Mostrarão Números Específicos;</p>\n<p>No Entanto, A Diferença Entre As Classificações Anteriores Será Exibida;</p>\n<p>Os 3 Primeiros Colocados Não Mostrarão A Diferença Entre Si.</p>',
  'total.rank.help.eu': '<h1>Tipo De Classificação</h1>\n<p>Classificação &lt;Doador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Que Receberam Como Presente.</p>\n<p>Classificação &lt;Encantador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Que Receberam Como Presente.</p>\n<h1>Ciclo De Tempo Da Classificação</h1>\n<p>A Classificação Mostra Os 3 Melhores Do Ciclo Anterior, Bem Como Os 50 Melhores Do Ciclo Atual, Atualizados Em Tempo Real.\n(Com Um Atraso De Menos De 1 Minuto)</p>\n<p>Horário De Atualização (Utc+3): Atualização Diária Da Classificação Às 5H; Atualização Semanal Da Classificação Às 5H Todas As Segundas-Feiras; Atualização Mensal Da Classificação Às 5H Do Primeiro Dia De Cada Mês.</p>\n<h1>Proteção De Privacidade</h1>\n<p>Algumas Classificações Não Mostrarão Números Específicos; </p>\n<p>No Entanto, A Diferença Entre As Classificações Anteriores Será Exibida; </p>\n<p>Os 3 Primeiros Colocados Não Mostrarão A Diferença Entre Si.</p>',
  'total.rank.help.eu.ios.hide': '<h1>Ciclo De Tempo De Classificação</h1>\n<p>A Classificação Mostra Os 3 Primeiros Do Ciclo Anterior, Bem Como Os 50 Melhores Do Ciclo Atual, Atualizados Em Tempo Real.\n(Com Um Atraso De Menos De 1 Minuto)</p>\n<p>Horário De Atualização (Utc+3): Atualização Diária Da Classificação Às 5H; Atualização Semanal Da Classificação Às 5H Todas As Segundas-Feiras; Atualização Mensal Da Classificação Às 5H Do Primeiro Dia De Cada Mês.</p>\n<h1>Proteção De Privacidade</h1>\n<p>Algumas Classificações Não Mostrarão Números Específicos;</p>\n<p>No Entanto, A Diferença Entre As Classificações Anteriores É Exibida;</p>\n<p>As 3 Primeiras Não Mostrarão A Diferença Entre Si.</p>',
  'total.rank.help.title': 'Regras De Classificação',
  'total.rank.hide': 'Esconder-Se Na Classificação',
  'total.rank.hide.info': 'Informações Ocultas',
  'total.rank.hide.name': 'Senhor Mistério',
  'total.rank.hour': 'De Hora Em Hora',
  'total.rank.last.day': 'Último Dia Top3',
  'total.rank.last.hour': 'Última Hora Top3',
  'total.rank.last.month': 'Top3 Do Mês Passado',
  'total.rank.last.week': 'Top3 Da Semana Passada',
  'total.rank.month': 'Mensal',
  'total.rank.room': 'Sala',
  'total.rank.sent': 'Tóxico',
  'total.rank.this.day': 'Este Dia',
  'total.rank.this.hour': 'Esta Hora',
  'total.rank.this.month': 'Este Mês',
  'total.rank.this.week': 'Essa Semana',
  'total.rank.week': 'Semanalmente',
  'viewMore': 'Ver Mais',
  'vip.help.1': 'Regras Vip',
  'vip.help.10': 'Se O Seu Valor De Exp Acumulado Atingir Os Requisitos Para Seu Nível Vip Atual Neste Mês, Você Manterá Seu Nível Vip No Próximo Mês; Caso Contrário, Seu Nível Vip Será Rebaixado No Mês Seguinte. Por Exemplo: Se Você For Vip5 Em Maio, Mas Tiver Acumulado Apenas Vip3 Em Maio, Seu Nível Vip Será Rebaixado Para Vip3 A Partir De Junho.',
  'vip.help.11': 'Desconto De Nível Vip',
  'vip.help.12': 'Com Base No Nível Vip Do Primeiro Dia De Cada Mês, Enviaremos Uma Certa Quantidade De Exp Vip Aos Usuários De Acordo Com Seus Níveis Vip No Primeiro Dia De Cada Mês.',
  'vip.help.13': 'Nível',
  'vip.help.14': 'Intervalo De Valor Exp',
  'vip.help.15': 'Reembolso De Valor Exp',
  'vip.help.2': 'O Que É O Vip?',
  'vip.help.3': 'Vip É A Classe Especial Do Soyou. Ela Inclui 11 Níveis De Identidade. Você Pode Obter Os Privilégios Correspondentes Após Adquirir Um Vip.',
  'vip.help.4': 'Como Aumentar O Nível Vip?',
  'vip.help.5': '1. Recarregue $1 Para Ganhar 1 Exp Vip.</br>\n2. Seu Nível Vip Será Atualizado Imediatamente Quando A Exp Vip Atingir O Requisito De Atualização Naquele Mês.</br>\n3. A Partir Do Primeiro Dia De Cada Mês, A Exp Vip Inicial De Cada Pessoa Será Zerada. E Seu Nível Vip Será Definido Pela Quantidade De Exp Acumulada.',
  'vip.help.6': 'Regras De Atualização De Nível Vip',
  'vip.help.7': 'Regras De Atualização',
  'vip.help.8': 'Ao Atingir As Condições De Upgrade Neste Mês, Seu Nível Vip Será Atualizado Imediatamente E Mantido Até O Final Do Mês Seguinte. Por Exemplo, O Usuário Atingiu O Vip5 Em 10 De Março E Seu Vip5 Continuará Até 30 De Abril.',
  'vip.help.9': 'Regras De Retenção/Rebaixamento',
  'vip.help.update.info': 'O Sistema Vip Foi Atualizado, Mas Sua Versão É Muito Antiga Para Visualizar Os Recursos Mais Recentes. Atualize Para A Versão Mais Recente E Aproveite A Nova Função Vip!',
  'vip.privileges.activate': 'Ativar Vip{N}',
  'vip.privileges.label.avatar': 'Moldura Exclusiva Para Mostrar Sua Identidade.',
  'vip.privileges.label.blockMessages': 'Bloqueie Mensagens De Estranhos E Não Seja Incomodado.',
  'vip.privileges.label.broadcast': 'Quando Você Atingir O Nível Vip8 Ou Superior, A Atualização Acionará Uma Notificação No Aplicativo.',
  'vip.privileges.label.bubble': 'O Balão De Bate-Papo Exclusivo Faz Seu Discurso Se Destacar.',
  'vip.privileges.label.exclusivevehicles': 'Personalize Sua Montaria Exclusiva. Ao Atingir O Nível Vip11, Entre Em Contato Com O Atendimento Ao Cliente Para Obter Um Veículo Personalizado. Cada Usuário Tem Apenas Uma Chance De Personalizar.',
  'vip.privileges.label.follower': 'Você Pode Se Tornar Vip E Adicionar Mais Amigos. Não Vip Pode Seguir 1.000 Pessoas. Vips 1 A 3 Aumentarão Em 1.000 Cada, Vips 4 A 6 Aumentarão Em 2.000 Cada, Vips 7 E Acima Aumentarão Em 3.000 Cada.',
  'vip.privileges.label.gif': 'Personalize Sua Armação Dinâmica Exclusiva. Ao Atingir O Nível Vip9, Entre Em Contato Com O Atendimento Ao Cliente Para Obter Uma Armação Dinâmica Personalizada. Cada Usuário Tem Apenas Uma Chance De Personalizá-La.',
  'vip.privileges.label.gift': 'Personalize Seu Presente Exclusivo. Ao Atingir O Nível Vip10, Entre Em Contato Com O Atendimento Ao Cliente Para Receber Presentes Personalizados. Cada Usuário Tem Apenas Uma Chance De Personalizar.',
  'vip.privileges.label.icon': 'Notável Selo Vip, Identidade Exclusiva De Usuários Vip, Demonstra Sua Honra.',
  'vip.privileges.label.id': 'Obtenha Seu Id Exclusivo E Deixe Que Os Outros Se Lembrem De Você Num Piscar De Olhos! Vip8: Ababab (A E B Devem Ser Diferentes) Vip9: Aaabb (A E B Devem Ser Diferentes) Vip10: Abab (A E B Devem Ser Diferentes) Vip11: Aabb (A E B Devem Ser Diferentes) Todos Os Formulários Não Podem Começar Com 0. Você Precisa Entrar Em Contato Com O Atendimento Ao Cliente Vip Para Obter Um Id Exclusivo.',
  'vip.privileges.label.invisible': 'Fique Invisível E Esconda-Se Nas Recomendações Dos Outros',
  'vip.privileges.label.list': 'Exibição Prioritária Dos Resultados Da Pesquisa.',
  'vip.privileges.label.message': 'Você Pode Colocar Diálogos De Outros Usuários No Topo Da Lista De Mensagens.',
  'vip.privileges.label.name': 'Os Usuários Receberão Efeitos Especiais Para Decorar O Nome De Usuário',
  'vip.privileges.label.open': 'Outros Podem Vê-Lo Automaticamente Ao Abrir O Aplicativo, Uma Glória Imbatível! Ao Atingir O Nível Vip12, Entre Em Contato Com O Atendimento Ao Cliente Para Obter Uma Página Aberta Personalizada De 24 Horas. Cada Usuário Tem Apenas Uma Chance De Personalizar.',
  'vip.privileges.label.picture': 'A Opção De Enviar Imagens No Chat De Marcadores',
  'vip.privileges.label.privacy': 'Outros Não Podem Pesquisar Você/Sua Sala De Voz',
  'vip.privileges.label.protection': 'Nunca Se Preocupe Em Ser Removido Do Microfone Ou De Qualquer Sala.',
  'vip.privileges.label.rank': 'Você Pode Ativar O Botão [Ocultar Identidade] Para Aparecer Como Um Homem Misterioso No Ranking.',
  'vip.privileges.label.room': 'Cartão Vip Exclusivo Para Sala',
  'vip.privileges.label.sign': 'Vip Pode Reivindicar Recompensas De Check-In Duplo',
  'vip.privileges.label.stealth': 'Quando Você Visita Outros Usuários, Nenhum Histórico Será Registrado',
  'vip.privileges.label.vehicle': 'Veículos Vip Exclusivos',
  'vip.privileges.label.visitor': 'Veja Todos Os Rastros De Visitantes Para Não Perder Nenhuma Pessoa Interessada Ou Fã.',
  'vip.privileges.stealth.close': 'Fechar',
  'vip.privileges.stealth.open': 'Abrir',
  'vip.privileges.stealth.text': 'Ocultar Meu Histórico De Acesso',
  'vip.privileges.title': 'Privilégios Vip',
  'vip.privileges.title.avatar': 'Moldura Vip',
  'vip.privileges.title.blockMessages': 'Modo Silencioso',
  'vip.privileges.title.broadcast': 'Notificação De Aplicativo',
  'vip.privileges.title.bubble': 'Balão De Bate-Papo Vip',
  'vip.privileges.title.exclusivevehicles': 'Veículo Personalizado',
  'vip.privileges.title.follower': 'Limite Superior De Seguimento Superior.',
  'vip.privileges.title.gif': 'Quadro Dinâmico Personalizado',
  'vip.privileges.title.gift': 'Presentes Personalizados',
  'vip.privileges.title.icon': 'Selo Vip',
  'vip.privileges.title.id': 'Id Exclusivo',
  'vip.privileges.title.invisible': 'Modo Invisível',
  'vip.privileges.title.list': 'Exibição De Prioridade',
  'vip.privileges.title.message': 'Lista De Mensagens Principais',
  'vip.privileges.title.name': 'Destaque Do Nome De Usuário',
  'vip.privileges.title.open': 'Página Aberta Personalizada',
  'vip.privileges.title.picture': 'Mini Cartão Exclusivo Para Destacar Sua Honra.',
  'vip.privileges.title.privacy': 'Segurança De Privacidade',
  'vip.privileges.title.protection': 'Impedir Remoção',
  'vip.privileges.title.rank': 'Ocultar Identidade',
  'vip.privileges.title.room': 'Cartão Mini Vip',
  'vip.privileges.title.sign': 'Recompensas De Check-In Vip',
  'vip.privileges.title.stealth': 'Visita Invisível',
  'vip.privileges.title.vehicle': 'Veículo Vip',
  'vip.privileges.title.visitor': 'Visitando Traços',
  'vip.privileges.update.info': 'O Sistema Vip Foi Atualizado, Mas Sua Versão É Muito Antiga Para Visualizar Os Recursos Mais Recentes. Atualize Para A Versão Mais Recente E Aproveite A Nova Função Vip!',
  'vip_introduce_1': '1. O Que É Vip',
  'vip_introduce_2': '2.Como Se Tornar Um Vip',
  'vip_introduce_3': '3. Período De Validade Vip',
  'vip_introduce_4': '4. Uso De Adereços Vip',
  'vip_introduce_text1': 'Vip É Um Sistema De Crescimento De Usuários. Atualmente, Existem 16 Níveis, Vip1 A Vip16. Quanto Maior O Nível Vip, Mais Direitos Você Terá E Mais Ricos Serão Os Adereços.',
  'vip_introduce_text2': 'Você Pode Obter Pontos De Experiência Vip Recarregando Moedas De Ouro. 1 Moeda De Ouro = 1 Ponto De Experiência. Quanto Mais Moedas De Ouro Você Recarregar, Mais Pontos De Experiência Você Ganha, E O Vip Subirá De Nível.',
  'vip_introduce_text3': 'Após A Obtenção Do Status Vip, Ele Se Torna Válido Permanentemente E Os Pontos De Experiência Vip São Acumulados Permanentemente E Não Serão Zerados. À Medida Que Os Pontos De Experiência Aumentam, Você Será Promovido A Um Nível Vip Mais Alto E Desfrutará De Mais Benefícios.',
  'vip_introduce_text4': 'Os Acessórios De Nível Vip Que Você Obtiver Ficarão Sempre Armazenados Na Sua Mochila E Poderão Ser Usados ​​A Qualquer Momento. Ao Subir De Nível, Os Acessórios De Nível Baixo Obtidos Ainda Poderão Ser Usados.',
  'vip_introduce_title': 'Introdução Às Regras Vip',
  'vip_introduce_welcome': 'Seja Bem-Vindo(A) Para Se Tornar Um Vip! O Vip Permitirá Que Você Desfrute De Mais Privilégios. A Seguir, Uma Introdução Sobre O Vip:',
  'vip_table1': 'Nível Vip',
  'voiceChat': 'Avaliações Do Usuário <br /> Para Bate-Papo Por Voz Com O Âncora',
  'voiceChat1': 'Avaliações Do Usuário <br /> Para Bate-Papo Por Voz Comigo',
  'withdraw_text_0': 'Renda',
  'withdraw_text_1': 'Equilíbrio',
  'withdraw_text_10': 'Diamante:',
  'withdraw_text_11': 'Agendar:',
  'withdraw_text_12': 'Em Revisão',
  'withdraw_text_13': 'Retirada Com Sucesso',
  'withdraw_text_14': 'A Retirada Falhou',
  'withdraw_text_15': 'Motivo Da Falha',
  'withdraw_text_16': 'Mostrar Apenas Registros Dos Últimos 3 Meses',
  'withdraw_text_2': 'Retirar',
  'withdraw_text_21': 'Valor De Retirada',
  'withdraw_text_22': 'Diamantes Deduzidos',
  'withdraw_text_23': 'Método De Pagamento:',
  'withdraw_text_24': 'Adicionar Método De Pagamento',
  'withdraw_text_25': 'Retirar Imediatamente',
  'withdraw_text_26': 'Verifique As Informações De Pagamento Corretamente. Informações Incorretas Resultarão Na Falha Do Saque E Taxas Adicionais Serão Arcadas Pelo Usuário.',
  'withdraw_text_27': 'Pergunta De Feedback',
  'withdraw_text_28': 'Entre Em Contato Com O Atendimento Ao Cliente',
  'withdraw_text_29': 'Dica:',
  'withdraw_text_3': 'Intercâmbio',
  'withdraw_text_30': '1. A Retirada É Permitida No Máximo Uma Vez Por Dia',
  'withdraw_text_31': '2. Você Deve Concluir A Autenticação Da Pessoa Real E Vincular O Método De Pagamento Antes De Iniciar Um Saque.',
  'withdraw_text_32': '3. A Plataforma Não Cobra Nenhuma Taxa. A Taxa De Serviço É Deduzida Pelo Canal. As Taxas De Serviço Variam De Acordo Com O Canal. Entre Em Contato Com O Atendimento Ao Cliente Do Canal Para Obter Mais Informações.',
  'withdraw_text_33': '4. O Progresso Da Retirada Pode Ser Visualizado Através Do ‘Registro De Retirada’',
  'withdraw_text_34': '5. Caso A Retirada Falhe, Os Diamantes Serão Devolvidos',
  'withdraw_text_35': '6. Os Pedidos De Retirada Serão Processados ​​Dentro De 7 A 14 Dias Úteis (Extensão Em Feriados)',
  'withdraw_text_36': 'Deve Ser Concluído',
  'withdraw_text_37': '1. Autenticação De Pessoa Real',
  'withdraw_text_38': '2. Adicionar Método De Pagamento',
  'withdraw_text_39': 'Vincular',
  'withdraw_text_4': 'Registro De Retiradas',
  'withdraw_text_40': 'Verificar',
  'withdraw_text_42': 'Nenhum Método De Pagamento Suportado',
  'withdraw_text_43': 'Há Pedidos Inacabados Para Este Método De Pagamento E Não Podem Ser Modificados Ou Excluídos Temporariamente.',
  'withdraw_text_44': 'Enviado Com Sucesso!',
  'withdraw_text_45': 'Tempo De Envio',
  'withdraw_text_46': 'O Dinheiro Chegará À Sua Conta Em Até 5 Dias Úteis. O Andamento Específico Pode Ser Verificado No Registro De Saque.',
  'withdraw_text_47': 'Completo',
  'withdraw_text_48': 'Método De Pagamento',
  'withdraw_text_5': 'Saldo De Diamante Insuficiente',
  'withdraw_text_59': 'Atualizar',
  'withdraw_text_6': 'Obtenha Mais Diamantes',
  'withdraw_text_7': 'Número Do Pedido:',
  'withdraw_text_8': 'Canal:',
  'withdraw_text_9': 'Quantia:',
  'world.cup.records': 'Registros',
  'world.cup.time': 'Tempo',
  'terms.help': 'Problemas com o App',
  'terms.bug': 'Bug',
  'terms.suggestions': 'Sugestões',
  'contacts.whatsapp': 'WhatsApp',
  'contacts.email': 'Email',
  'contacts.phone': 'Telefone',
  'submit.success': 'Obrigado pelo seu feedback',
  'terms.title': 'Categoria',
  'details.placeholder': 'Descreva os detalhes do seu problema',
  'contacts.title': 'Como entrar em contato com você?',
  'contact.placeholder': 'Deixe seus dados de contato',
  'submit.btn': 'Enviar',
  'country.select.hot': 'Populares',
  'country.select.all': 'Todos',
  'feedback.details': 'Detalhes',
  'feedback.screenshot': 'Captura de Tela (Opcional)',
  'feedback.title': 'Feedback',
  'subTitle': 'Não confie em outros canais de recarga além dos comerciantes verificados.',
  'chat': 'Chat',
  'id': 'SOYO ID',
  'contact': 'Contato',
  'whatsapp': 'WhatsApp',
  'right': 'A Equipe SOYO reserva-se o direito de interpretação final.',
  'check': 'A senha deve conter 8 caracteres, incluindo números, letras maiúsculas e minúsculas',
  'same': 'Digite a mesma senha',
  'copied': 'Copiado',
  'about.title': 'Sobre',
  'Return Policy': 'Política de Devolução',
  'Intellectual Property Rights': 'Direitos de Propriedade Intelectual',
  'Contact Us': 'Contate-Nos',
  'About Us': 'Sobre Nós',
  'Supported Payment Methods': 'Métodos de Pagamento Suportados',
  'retirar.rules.title': 'Regras de Saque',
  'retirar.rules.rules.1': '1.Antes de usar o serviço de saque, é necessário enviar informações de identidade reais para garantir a segurança da conta.',
  'retirar.rules.rules.2': '2.Por favor, forneça informações de identidade reais, que serão usadas como base para a identificação e a determinação do direito de uso da sua conta.',
  'retirar.rules.rules.3': '3.As informações de identidade que você enviar serão mantidas estritamente confidenciais e não serão usadas para outros fins.',
  'retirar.rules.chat': 'Contatar Atendimento ao Cliente',
  'retirar.rules.important': 'Destaque:',
  'retirar.rules.rules.extra': '4.Entre em contato com o Atendimento ao Cliente quando precisar usar o serviço de saque e forneça as seguintes informações:',
  'retirar.rules.rules.extra.1': 'Nome real',
  'retirar.rules.rules.extra.2': 'Número do WhatsApp',
  'retirar.rules.rules.extra.3': 'Documentos de identidade (cartão de identidade, passaporte, etc.)',
  'retirar.rules.rules.extra.4': 'Seu método de pagamento (Transferência Bancária, Payoneer, Fawry, etc.)',
  'income.rules.rules.1': '1.Regras de Pagamento: As 00:00 do 16º dia de cada mês e do 1º dia do mês seguinte, o valor será deduzido do saldo de diamantes da conta.',
  'income.rules.rules.2': '2.Razão de Pagamento: 1 USD = 0 diamantes.',
  'income.rules.rules.3': '3.Horário de Liquidação: ① 00:00 do 16º dia de cada mês ② 00:00 do 1º dia do mês seguinte.',
  'income.rules.rules.4': '4.Settlement Period: 7~14 working days(holidays are postponed)',
  'income.rules.chat': 'Contatar Atendimento ao Cliente',
  'income.rules.important': 'Destaque:',
  'income.rules.title': 'Regras de Salário',
  'income.rules.rules.extra': 'Será notificado via \"Equipe\" quando o pagamento for liquidado. Os detalhes da dedução de diamantes podem ser consultados em \"Renda\". Acompanhe as notificações da Equipe. A liquidação normal será concluída em 7-14 dias úteis. Em caso de feriados, o prazo de liberação bancário será adiado. Agradecemos sua paciência. Se houver dúvidas, entre em contato com o Atendimento ao Cliente. Obrigado pelo seu suporte',
  'income.rules.usd': 'USD',
  'income.rules.diamonds': 'Diamantes',
  'home.recharge': 'Recarga',
  'home.slogan': 'Encontre seu alma gêmea aqui <br />Sempre com você',
  'home.download': 'Download',
  'recharge.result.success': 'Pagamento Bem-Sucedido',
  'recharge.result.error': 'Pagamento Falhou',
  'recharge.result.jumping_to_app': 'Redirecionando para o App...',
  'recharge.result.app_not_installed': 'App não instalado',
  'recharge.result.download_app_tip': 'Baixe e instale o app para continuar',
  'report.option.Porn': 'Pornografia',
  'report.option.Spam': 'Spam',
  'report.option.Fraud': 'Fraude',
  'report.option.Violence': 'Violência',
  'report.option.Illegal': 'Ilegal',
  'report.option.Other': 'Outros',
  'report.option.room': 'Não gosto disso',
  'report.option.user': 'Não gosto do usuário',
  'report.reason': 'Categoria',
  'report.details': 'Detalhes',
  'report.details.placeholder': 'Descreva os detalhes da sua denúncia',
  'report.screenshot': 'Captura de Tela (Opcional)',
  'report.submit': 'Enviar',
  'report.submit.success': 'Denúncia Enviada com Sucesso',
  'report.room': 'Denunciar',
  'report.user': 'Denunciar Usuário',
};

export default PT;
